import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { INGREDIENT_COLUMN_NO, CREATE_RECIPE_COLUMNS_NO, INGHEADERINFO, INGHEADERINFO_FOR_EDIT_ING, SUBSTANCE_DETAILS, SUBSTANCE_DETAILS_IN_EDIT_ING } from 'src/app/common/models/tableColumns';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanComponentDeactivate } from 'src/app/guards/can-deactivate.guard';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { CreateRecipeService } from './create-recipe.service';
import * as _ from 'lodash';
import { AssessRequestRaService } from 'src/app/assess-request-ra/assess-request-ra.service';
import { recipeModel } from 'src/app/common/models/recipeDetailsModel';
import { AssessmentRequestService } from 'src/app/assess-requests/assess-requests.service';
import { DatePipe } from '@angular/common';
import { SirDetails } from 'src/app/common/models/GroupDataModel';
import { DataService } from 'src/app/common/services/data.service';
import { Dropdown } from 'primeng';
import { ChangeDetectorRef } from '@angular/core';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}
@Component({
  selector: 'app-create-recipe',
  templateUrl: './create-recipe.component.html',
  styleUrls: ['./create-recipe.component.scss']
})

export class CreateRecipeComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('substanceDropdown') dropdown!: Dropdown;
  @ViewChild('substanceTable') substancesTable!: ElementRef;
  @ViewChildren('plmsubstanceDropdown') plmdropdowns!: QueryList<Dropdown>;

  items: any[] = [];
  star = 'fa fa-fw fa-search';
  readOnlyValue: any;
  todayDate;
  defaultMaxDate;
  issueCategoryList = [];
  selectedIssueCategory = [];
  commentsToUser = '';
  defaultEndDate;
  defaultStartDate;
  defaultStartDateRcp;
  disablebtn = false;
  defaultMinDate;
  value: any;
  invalidINGCalc = true;
  invalidSIRCalc = true;
  calculatedINGQty: any;
  lockform: any;
  savebuttonflg: any;
  calculatedSIRQty: any;
  compositionnotvalidated: any;
  OneStarAPIResponse: any = [];
  uniqLocalIngID: any = [];
  ingredientListData: any = [];
  popupNotValidated = false;
  mandatoryentrymissing = 1;
  segregatecompositionData = [];
  plmIngredient: {ingDescription: string; ingID: number}[] = [];
  tempCompositionData = [];
  orgCompositionData = [];
  compositionDetailsColumns = [];
  editIngTable1Cols = [];
  editIngTable1Data = [{
    ingID: null,
    ingDescription: null,
    ingQuantity: null,
    oldingID: null,
    isTemporaryIngredient: null,
    ingType: null
  }];
  uploadDialog = false;
  showConfirmDelete = false;
  filteredvalidityArea = [];
  validityAreavals = [];
  validityAreaVal: any;
  recipeValidated: any;
  editIngredientDialog = false;
  addIngredient = false;
  uploadedFiles: any[] = [];
  loadingmappinglistMessage = '';
  UploadData: any = [];
  buttonSelection = false;
  editIngSelection: any = '';
  substanceListOfEditIng: any[] = [];
  searchIdentifierValue = null;
  sirSearchResult = [];
  disablePureCode = false;
  sirDetails = Array<SirDetails>();
  sirObjSelectedIndex = null;
  showPuremsg = false;
  totalSirPercent = 0.0;
  editFlagFirst = 0;
  groupedChemicals: any = [];
  selectedChemical: string;
  substanceOptions: any[] = [];
  selectedSubstance: any;
  recipeDescription = '';
  recipeComment = '';
  recipeId = '';
  recipeVersion = '';
  showRecipeSavedDialog = false;
  showRecipeCompletedDialog = false;
  showDialogAfterCreateReqClicked = false;
  cancelClicked = false;
  copyRecipeFlag = false;
  editRecipeFlag = false;
  copyOrEditRecipeForm: any;
  createRequestForm = {
    nonPlmrecipeId: null,
    nonPlmrecipeId_Version: null
  };
  showFinalizeConfirmation = false;
  redirectToCreateRequestPg = false;
  showredirectpopup = true;

  // Fields For Formulation Details
  tfcDetailsfromPlm: any;
  filteredDataUpd: any[] = [];
  groupsData: any = '';
  loading = true;
  updNameDataApi = '';
  selectedUpd: any;
  selectedFC: any;
  selectedType: any;
  selectedClass: any;
  selectedSubClass: any;
  CatNewData: any = [];
  typeNewData: any = [];
  classNewData: any = [];
  SubclassNewData: any = [];
  filteredDataCat: any[] = [];
  filteredDataType: any[] = [];
  filteredDataClass: any[] = [];
  filteredDataSubclass: any[] = [];
  isFormulationCategory = true;
  isFormulationType = true;
  isFormulationClass = true;
  isFormulationSubClass = true;
  restrictedTovalue = '';
  restrictedToError = '';
  restrictedUsers: any = [];

  prepartionMethodValues = [{ id: 1, value: 'As Sold' }, { id: 2, value: 'As Prepared' }];
  selectedPrepMethod;
  ingredientDetailsColumns = [];
  importfromPlm = false;
  importFromPLMDetail = [];
  additionalfielderror;
  activeTab = 'plm-ing-tab';
  cucaltver: any = '';
  validityarea: any = [];
  plmvalidityareaedit: any;
  onestarIngID: any = '';
  keydate: any = new Date();
  formAssess: any;
  recipeModel = {
    recipeID: '',
    recipeVer: '',
    recipeDescription: '',
    tfcList: null,
    prepMethod: [],
    recipeStatus: '',
    formulationRequestDetails: [],
    recipeComments: ''
  };
  ingResponseData: any;
  ingredientIdOrName = '';
  plmvalidityarea: any;
  plmkeydate: any;
  ingHeaderData = {
    ingID: '',
    ingDescription: '',
    ingQuantity: null,
    ingType: null
  };
  IngHeaderInfo = [];
  IngHeaderInfoForEditIng = [];
  ingHeaderDataInformation = [];
  substanceDetailsData = [];
  substanceDetailsCols = [];
  substanceDetailsColsInEditIng = [];
  errorMessage = '';
  loadingPlmmessage: string;
  addIngredientDialogNonplm = false;
  loadingMessage: string;
  isplmDataValid = false;
  isAddSubstanceEnable = true;
  isIngValidData = false;
  errorMessagechildIng: string;
  clickedRows: any = [];
  calculatedImpINGQty = 0.000000;
  filteredIngItems: any[] = [];
  selectedIngItem: any[] = [];
  ingDetails = {
    ingID: '',
    ingDescription: '',
  };
  minRange = 0.00001;
  maxRange = 100.01;
  invalidTotalINGCalc = true;
  invalidTotalSIRCalc = true;
  dynamicMinLen = 3;
  errorIngMessage = 'No records found';
  isIngDescriptionDisabled = true;
  isCreateRecipeDialog = false;
  isRecipeSourceImportFromPlm = false;
  recipeSource: string;
  oldRecipeSourceValue: string;
  cucSource = '';

  isSIRClicked = false;
  isNotifyClicked: boolean;
  rowDetails = {};
  search(event: AutoCompleteCompleteEvent) {
    this.items = [...Array(10).keys()].map(item => event.query + '-' + item);
  }
  canDeactivate(): boolean {
    if (this.showredirectpopup === true) {
      const confirmLeave = confirm('Please ensure you have saved your data before progressing');
      if (confirmLeave) {
        this.cleanupCode();
      }
      return confirmLeave;
    } else {
      return true;
    }

  }

  constructor(
    public matSnackBar: MatSnackBar,
    private apiService: CreateRecipeService,
    private http: HttpClient,
    public fb: FormBuilder,
    private datePipe: DatePipe,
    public router: Router,
    private assessRequestRa: AssessRequestRaService,
    public assessService: AssessmentRequestService,
    private dataTrans: DataService,
    private cdr: ChangeDetectorRef
  ) { }
  ngOnInit() {

    this.compositionnotvalidated = 1;
    this.todayDate = new Date();
    this.lockform = 0;
    this.mandatoryentrymissing = 1;
    this.savebuttonflg = 1;
    this.defaultStartDate = this.datePipe.transform(this.todayDate, 'dd-MM-yyyy');
    this.compositionDetailsColumns = CREATE_RECIPE_COLUMNS_NO;
    this.getGroupData();
    this.getvalidityArea();
    this.IngHeaderInfo = INGHEADERINFO;
    this.IngHeaderInfoForEditIng = INGHEADERINFO_FOR_EDIT_ING;
    this.substanceDetailsCols = SUBSTANCE_DETAILS;
    this.substanceDetailsColsInEditIng = SUBSTANCE_DETAILS_IN_EDIT_ING;
    this.loading = false;
    this.calculatedSIRQty = 0;
    this.calculatedINGQty = 0;
    this.invalidINGCalc = true;
    this.invalidSIRCalc = true;
    this.selectedPrepMethod = this.prepartionMethodValues[0];
    this.updateTotalSirPercent();
    this.ingredientDetailsColumns = INGREDIENT_COLUMN_NO;
    this.todayDate = new Date();
    this.defaultMaxDate = new Date('2099-12-31');
    this.defaultMinDate = new Date('2000-01-01');
    this.defaultEndDate = this.datePipe.transform(new Date('2099-12-31'), 'longDate');
    this.defaultStartDate = this.datePipe.transform(this.todayDate, 'dd-MM-yyyy');
    this.defaultStartDateRcp = this.datePipe.transform(this.todayDate, 'dd-MM-yyyy');
    this.copyOrEditRecipe();
    this.cucSource = '';
    if (this.editRecipeFlag) {
      this.isCreateRecipeDialog = false;
    } else if (this.copyRecipeFlag) {
      this.isCreateRecipeDialog = false;
    } else {
      this.isCreateRecipeDialog = true;
    }
  }
  openCompositionDetails(index) {
  }
  UploadDialog() {
    this.uploadDialog = true;
  }
  openCreateDialog() {
    this.isCreateRecipeDialog = true;
  }
  addIngredientDialog() {
    this.isSIRClicked = false;
    this.errorMessage = '';
    this.errorIngMessage = 'No records found';
    this.invalidSIRCalc = true;
    this.isImportAddEnable();
    this.totalSirPercent = 0.0;
    this.addIngredient = true;
    this.ingHeaderDataInformation = [];
    this.substanceDetailsData = [];
    this.clearAll();
    this.plmvalidityarea = this.validityarea.validityAreaCode;
    this.createIngHeaderInformation('', '', 0, '');
    this.loadingmappinglistMessage = 'Fetching ING details';
    this.isIngDescriptionDisabled = false;
    this.disableIngSubmitButton();
  }

  // Code For Formulation Details
  getGroupData() {
    const apiurl = environment.APIFAsT + '/GetSubstanceSearchUPDsfornonplmbg';
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.groupsData = response1;
    });
  }
  cleanupCode() {
    if (this.editRecipeFlag && this.recipeId && this.recipeVersion) {
      // Only For In-progress recipe Edit
      this.removeEditLockFromDB();
    }
  }
  searchUpd(event) {
    const filteredSearchupd = [];
    const query = event.query;
    for (const value of this.groupsData) {
      if (value.updName.toLowerCase().includes(query.toLowerCase())) {
        filteredSearchupd.push(value);
      }
    }
    this.filteredDataUpd = filteredSearchupd;
  }

  updSelected(event): void {
    this.updNameDataApi = event.updName;
    this.clearCategory();
    this.getGroupDataFormulationCategory(event);
    this.selectedFC = null;
  }

  searchFormulationCategory(event) {
    const filteredSearchCat = [];
    const query = event.query;
    for (const value of this.CatNewData) {
      if (value.tfcLevel1Name.toLowerCase().includes(query.toLowerCase())) {
        filteredSearchCat.push(value);
      }
    }
    this.filteredDataCat = filteredSearchCat;
  }
  SelectedFormulationCategory(val): void {
    this.clearType();
    this.getGroupDataFormulationType(val);
    this.selectedType = null;
    this.validateRestrictedToEmails();
  }

  searchFormulationType(event) {
    const filteredSearchType = [];
    const query = event.query;
    for (const value of this.typeNewData) {
      if (value.tfcLevel2Name.toLowerCase().includes(query.toLowerCase())) {
        filteredSearchType.push(value);
      }
    }
    this.filteredDataType = filteredSearchType;
  }
  selectedFormulationType(val): void {
    const data = val.tfcLevel2Name;
    this.clearClass();
    this.getGroupDataFormulationClass(val);
    this.selectedClass = null;
  }

  searchFormulationClass(event) {
    const filteredSearchClass = [];
    const query = event.query;
    for (const value of this.classNewData) {
      if (value.tfcLevel3Name.toLowerCase().includes(query.toLowerCase())) {
        filteredSearchClass.push(value);
      }
    }
    this.filteredDataClass = filteredSearchClass;
  }
  SelectedFormulationClass(val): void {
    this.clearSubClass();
    this.getGroupDataFormulationSubClass(val);
    this.selectedSubClass = '';
  }

  searchFormulationSubClass(event) {
    const filteredSearchSubclassData = [];
    const query = event.query;
    for (const value of this.SubclassNewData) {
      if (value.tfcLevel4Name.toLowerCase().includes(query.toLowerCase())) {
        filteredSearchSubclassData.push(value);
      }
    }
    this.filteredDataSubclass = filteredSearchSubclassData;
  }
  SelectedFormulationSubClass(val): void {
    const subClassValue = val.tfcLevel4Name;

  }

  getGroupDataFormulationCategory(typeValue) {
    const apiurl = environment.APIFAsT + '/upd/' + this.updNameDataApi + '/tfc/level/1/' + typeValue.updId;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.CatNewData = response1;
    }, (error) => {
      this.loading = false;
    });
  }

  getGroupDataFormulationType(event) {
    const apiurl = environment.APIFAsT + '/upd/' + this.updNameDataApi + '/tfc/level/2/' + event.tfcLevel1Id;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.typeNewData = response1;
    }, (error) => {
      this.loading = false;
    });
  }

  getGroupDataFormulationClass(val) {
    const apiurl = environment.APIFAsT + '/upd/' + this.updNameDataApi + '/tfc/level/3/' + val.tfcLevel2Id;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.classNewData = response1;
    }, (error) => {
      this.loading = false;
    });
  }

  getGroupDataFormulationSubClass(val) {
    const apiurl = environment.APIFAsT + '/upd/' + this.updNameDataApi + '/tfc/level/4/' + val.tfcLevel3Id;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.SubclassNewData = response1;
    }, (error) => {
      this.loading = false;
    });
  }

  clearUPD() {
    this.clearDropdownvalues(true, true, true, true);
  }

  clearCategory() {
    this.clearDropdownvalues(false, true, true, true);
  }
  clearType() {
    this.clearDropdownvalues(false, false, true, true);
  }
  clearClass() {
    this.clearDropdownvalues(false, false, false, true);
  }
  clearSubClass() {
    this.clearDropdownvalues(false, false, false, false);
  }
  clearDropdownvalues(category, type, fclass, subclass) {
    if (category) {
      this.selectedFC = null;
      this.filteredDataCat = [];
    }
    if (type) {
      this.selectedType = null;
      this.filteredDataType = [];
    }
    if (fclass) {
      this.selectedClass = undefined;
      this.filteredDataClass = [];
    }
    if (subclass) {
      this.selectedSubClass = undefined;
      this.filteredDataSubclass = [];
    }
    this.enableordisable(category, type, fclass, subclass);
  }

  enableordisable(category, type, fclass, subclass) {
    this.isFormulationCategory = category;
    this.isFormulationType = type;
    this.isFormulationClass = fclass;
    this.isFormulationSubClass = subclass;
  }

  populateTfcData(tfcDetails) {
    if (tfcDetails) {
      const tfc = {
        updId: '',
        updName: '',
        businessGroupName: '',
        bgid: '',
        formulationCategory: '',
        tfcLevel1Id: '',
        tfcFullTextFC: '',
        formulationType: '',
        tfcLevel2Id: '',
        tfcFullTextFT: '',
        formulationClass: '',
        tfcLevel3Id: '',
        tfcFullTextFCls: '',
        formulationSubClass: '',
        tfcLevel4Id: '',
        tfcFullTextFSC: '',
      };
      tfc.bgid = tfcDetails.parentTFC.parentTFC.parentTFC.parentTFC.bgid ? tfcDetails.parentTFC.parentTFC.parentTFC.parentTFC.bgid : '';
      tfc.businessGroupName = tfcDetails.parentTFC.parentTFC.parentTFC.parentTFC.businessGroupName ? tfcDetails.parentTFC.parentTFC.parentTFC.parentTFC.businessGroupName : '';
      tfc.updName = tfcDetails.parentTFC.parentTFC.parentTFC.parentTFC.tfcName ? tfcDetails.parentTFC.parentTFC.parentTFC.parentTFC.tfcName : '';
      tfc.updId = tfcDetails.parentTFC.parentTFC.parentTFC.parentTFC.tfcId ? tfcDetails.parentTFC.parentTFC.parentTFC.parentTFC.tfcId : '';
      tfc.formulationCategory = tfcDetails.parentTFC.parentTFC.parentTFC.tfcName ? tfcDetails.parentTFC.parentTFC.parentTFC.tfcName : '';
      tfc.tfcLevel1Id = tfcDetails.parentTFC.parentTFC.parentTFC.tfcId ? tfcDetails.parentTFC.parentTFC.parentTFC.tfcId : '';
      tfc.tfcFullTextFC = tfcDetails.parentTFC.parentTFC.parentTFC.tfcFullText ? tfcDetails.parentTFC.parentTFC.parentTFC.tfcFullText : '';
      tfc.formulationType = tfcDetails.parentTFC.parentTFC.tfcName ? tfcDetails.parentTFC.parentTFC.tfcName : '';
      tfc.tfcLevel2Id = tfcDetails.parentTFC.parentTFC.tfcId ? tfcDetails.parentTFC.parentTFC.tfcId : '';
      tfc.tfcFullTextFT = tfcDetails.parentTFC.parentTFC.tfcFullText ? tfcDetails.parentTFC.parentTFC.tfcFullText : '';
      tfc.formulationClass = tfcDetails.parentTFC.tfcName ? tfcDetails.parentTFC.tfcName : '';
      tfc.tfcLevel3Id = tfcDetails.parentTFC.tfcId ? tfcDetails.parentTFC.tfcId : '';
      tfc.tfcFullTextFCls = tfcDetails.parentTFC.tfcFullText ? tfcDetails.parentTFC.tfcFullText : '';
      tfc.formulationSubClass = tfcDetails.tfcName ? tfcDetails.tfcName : '';
      tfc.tfcLevel4Id = tfcDetails.tfcId ? tfcDetails.tfcId : '';
      tfc.tfcFullTextFSC = tfcDetails.tfcFullText ? tfcDetails.tfcFullText : '';
      this.updNameDataApi = tfc.businessGroupName;
      this.getGroupData();
      if (tfc.updId && tfc.businessGroupName) {
        this.updSelected({ updId: tfc.bgid, updName: tfc.businessGroupName });
        this.selectedUpd = { updName: tfc.businessGroupName, updId: tfc.bgid, tfcFullText: tfc.businessGroupName };
      }
      if (tfc.tfcLevel1Id) {
        this.SelectedFormulationCategory({ tfcLevel1Id: tfc.tfcLevel1Id });
        this.selectedFC = { tfcLevel1Name: tfc.formulationCategory, tfcLevel1Id: tfc.tfcLevel1Id, tfcFullText: tfc.tfcFullTextFC };
      }
      if (tfc.tfcLevel2Id) {
        this.selectedFormulationType({ tfcLevel2Id: tfc.tfcLevel2Id });
        this.selectedType = { tfcLevel2Name: tfc.formulationType, tfcLevel2Id: tfc.tfcLevel2Id, tfcFullText: tfc.tfcFullTextFT };
      }
      if (tfc.tfcLevel3Id) {
        this.SelectedFormulationClass({ tfcLevel3Id: tfc.tfcLevel3Id });
        this.selectedClass = { tfcLevel3Name: tfc.formulationClass, tfcLevel3Id: tfc.tfcLevel3Id, tfcFullText: tfc.tfcFullTextFCls };
      }
      if (tfc.tfcLevel4Id) {
        this.selectedSubClass = { tfcLevel4Name: tfc.formulationSubClass, tfcLevel4Id: tfc.tfcLevel4Id, tfcFullText: tfc.tfcFullTextFSC };
      }
    }
  }
  // End of Code for formulation details

  onUpload(event, fileuploadForm) {
    this.uploadedFiles = [];
    for (const file of event.files) {
      this.uploadedFiles.push(file);
    }
    fileuploadForm.clear();
    this.loadingmappinglistMessage = 'Loading data in Composition Details table';
    const fileToUpload = <File> this.uploadedFiles[0];
    const apiurl = environment.APIFAsT + '/nonPLMRecipe/recipedata/uploadfile';
    this.loading = true;
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    const headerdata = new HttpHeaders({
      Authorization: 'Bearer ' + localStorage.getItem('FunctionToken'),
      'X-FAST-AUTH-K': '6ee2a098-e2d6-4893-b8b4-18f01c9a67a1-6DB1487E-C741-4669-B8BB-9F34EE294EEF'
    });
    this.http.post<any>(apiurl, formData, { headers: headerdata })
      .subscribe((response) => {
        this.UploadData = response;
        // console.log(this.UploadData);
        this.loading = false;
        this.uploadDialog = false;
        // const oneStarIngsInMainTable = new Set(this.segregatecompositionData.map(item => item.ingID));
        const uniqueOneStarIngsFromExcelFile = this.UploadData; // .filter(item => !oneStarIngsInMainTable.has(item.ingID));
        // const duplicatesIngsFromExcel = this.UploadData.filter(item => oneStarIngsInMainTable.has(item.ingID));
        if (uniqueOneStarIngsFromExcelFile !== undefined && uniqueOneStarIngsFromExcelFile.length !== 0) {
          this.ingredientListData = uniqueOneStarIngsFromExcelFile.map(respElem =>
            respElem.ingPureDetails.map(pure => ({
              ingID: respElem.ingID,
              ingName: respElem.ingDescription,
              ingredientPer: respElem.ingQuantity,
              ingredientType: respElem.ingType,
              pureCode: pure.pureCode,
              subName: pure.substanceName,
              sirId: pure.substanceID,
              casNumber: pure.casNumber,
              inciName: pure.inciNumber,
              einecs: pure.einecsNumber,
              sirPercentageInIng: pure.recipeQuantity,
              sirQty: pure.pureQuantityPerItem,
              uom: pure.recipeUoM,
              errorDetails: null,
              isTemporaryIngredient: respElem.isTemporaryIngredient,
            }))
          );
        }
        console.log(this.ingredientListData);
        this.ingredientListData = this.ingredientListData.flat();
        console.log(this.ingredientListData);
        this.segregatecompositionData = [];
        this.segregatecompositionData = this.ingredientListData;
        // if (duplicatesIngsFromExcel.length > 0) {
        //   const duplicateIdsString = duplicatesIngsFromExcel.map(item => item.ingID).join(', ');
        //   const message = 'Ingredient ' + duplicateIdsString + ' is not added as it is already present in the composition';
        //   this.matSnackBar.open(message, 'close', {
        //     duration: 7000,
        //     panelClass: ['error']
        //   });
        // }
        this.updateCompTableWithRoundedValues();
        this.calculateingQtySIRQty();
        this.validateCompositionDetail();
        this.enableOrDisableCompleteRecipeBtn();
        // this.loadIngredientTable();
      }, (error) => {
        this.uploadDialog = false;
        this.loading = false;
        if (error.error.message !== undefined) {
          this.matSnackBar.open(error.error.message, 'close', {
            duration: 5000,
            panelClass: ['error']
          });
        }
      });

  }
  validateOtherDetailsforRecipe() {
    this.invalidTotalINGCalc = false;
    this.invalidTotalSIRCalc = false;
    this.compositionnotvalidated = 0;
    if (this.recipeDescription === null || this.recipeDescription === '' || this.recipeDescription.trim() === '') {
      this.compositionnotvalidated = 1;
      this.savebuttonflg = 1;
    }
    if (this.segregatecompositionData.length > 0) {
      this.segregatecompositionData.forEach(item => {
        if (item.errorDetails === 'Invalid Substance') {
          this.compositionnotvalidated = 1;
          // incase if error details is having invalid substance, no other checks will be performed.

        } else {
          item.errorDetails = 'No Issues Found';
          if (isNaN(parseFloat(item.ingredientPer)) || !isFinite(item.ingredientPer)) {
            item.errorDetails = 'Invalid Ingredient %';
            this.compositionnotvalidated = 1;
          }
          if (isNaN(parseFloat(item.sirPercentageInIng)) || !isFinite(item.sirPercentageInIng)) {
            item.errorDetails = 'Invalid Substance %';
            this.compositionnotvalidated = 1;
          }
          if (!(isNaN(parseFloat(item.sirPercentageInIng)) || !isFinite(item.sirPercentageInIng))) {
            item.sirQty = (item.ingredientPer * item.sirPercentageInIng) / 100;
            if (isNaN(parseFloat(item.sirQty)) || !isFinite(item.sirQty)) {
              item.errorDetails = 'Invalid Substance Qty%';
              this.compositionnotvalidated = 1;
            }
          }
          if (item.uom === '' || item.uom === null) {
            item.errorDetails = 'Invalid UoM';
            this.compositionnotvalidated = 1;
          }
        }


      });
      this.updateCompTableWithRoundedValues();
      this.calculateingQtySIRQty();
    } else {
      this.recipeValidated = 0;
      this.compositionnotvalidated = 1;
    }
    if (!(this.selectedUpd && this.selectedFC && this.selectedType && this.selectedClass && this.selectedSubClass && this.selectedPrepMethod)) {
      this.compositionnotvalidated = 1;
    }
    this.enableOrDisableCompleteRecipeBtn();
  }
  validateCompositionDetail() {
    this.loading = true;
    this.savebuttonflg = 0;
    let substancestring = '';
    this.segregatecompositionData.forEach(item => {
      if (substancestring === '') {
        substancestring = item.sirId;
      } else {
        substancestring = substancestring + ',' + item.sirId;
      }
    });
    this.loadingmappinglistMessage = 'Validating Substances';
    this.substanceOptions = [];
    const apiurl = environment.APIFAsT + '/substancelistfornonplm/' + substancestring;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.sirSearchResult = response1;
      this.segregatecompositionData.forEach(element => {
        const substanceFound = this.sirSearchResult.filter(f => f.sirId === element.sirId);
        if (substanceFound.length !== undefined) {
          if (substanceFound.length <= 0) {
            element.errorDetails = 'Invalid Substance';
            this.disablebtn = true;
            this.compositionnotvalidated = 1;
          }
        } else {
          element.errorDetails = 'Invalid Substance';
          this.disablebtn = true;
          this.compositionnotvalidated = 1;
        }
      });
      this.loading = false;
      console.log(this.substanceOptions);
      this.validateOtherDetailsforRecipe();
    }, (error) => {
      this.recipeValidated = 0;
      this.compositionnotvalidated = 1;
      this.calculateingQtySIRQty();
      this.loading = false;
    });
  }
  calculateingQtySIRQty() {
    if (this.segregatecompositionData.length > 0) {
      const seen = new Set();
      let totalIngredientPer = 0;
      let totalSIRQty = 0;
      this.segregatecompositionData.forEach(item => {
        totalSIRQty += Number(item.sirQty);
        if (!seen.has(item.ingID)) {
          seen.add(item.ingID);
          totalIngredientPer += Number(item.ingredientPer);
        }
      });
      this.calculatedINGQty = this.roundIfMoreThan6Decimals(totalIngredientPer);
      this.calculatedSIRQty = this.roundIfMoreThan6Decimals(totalSIRQty);
    } else {
      this.calculatedINGQty = this.roundIfMoreThan6Decimals(0);
      this.calculatedSIRQty = this.roundIfMoreThan6Decimals(0);
    }
    this.invalidTotalINGCalc = false;
    this.invalidTotalSIRCalc = false;
    if (!(this.isValidTotalRange(this.calculatedINGQty, 'ING'))) {
      this.recipeValidated = 0;
      this.compositionnotvalidated = 1;
      this.invalidTotalINGCalc = true;
    }
    if (!(this.isValidTotalRange(this.calculatedSIRQty, ''))) {
      this.recipeValidated = 0;
      this.compositionnotvalidated = 1;
      this.invalidTotalSIRCalc = true;
    }
  }
  loadIngredientTable() {
    this.segregatecompositionData = this.segregatecompositionData.concat(this.ingredientListData);
  }
  updateEditIngvaluetoMain() {
    this.compositionnotvalidated = 1;
    this.orgCompositionData = this.segregatecompositionData;
    this.tempCompositionData = this.segregatecompositionData;
    this.tempCompositionData = this.tempCompositionData.filter(f => f.ingID !== this.editIngTable1Data[0].oldingID);
    this.loadingmappinglistMessage = 'Checking for Duplicacy of Ingredient Name';
    this.loading = true;
    if (this.tempCompositionData.length > 0 && this.tempCompositionData.filter(f => f.ingName.trim().toLowerCase() === this.editIngTable1Data[0].ingDescription.trim().toLowerCase()).length > 0) {
      this.errorMessage = 'Ingredient name already exists in this recipe. Please try again with a unique ingredient name.';
      this.loading = false;
      return false;
    } else {
      this.loading = false;
    }
    this.segregatecompositionData = [];
    // this.segregatecompositionData = this.segregatecompositionData.concat(this.tempCompositionData);
    let substanceRow = {};
    if (this.editIngTable1Data[0].ingID === '--') {
      this.loadingmappinglistMessage = 'Checking for Duplicacy of Ingredient Name';
      this.loading = true;
      const encodedIngName = encodeURIComponent(this.editIngTable1Data[0].ingDescription.trim());
      const apiurlnew = environment.APIFAsT + '/getduplicacycheckoningredientname?ingname=' + encodedIngName ;
      this.apiService.getData(apiurlnew).subscribe((response1) => {
        this.loading = false;
        if (response1.message === 'Duplicacy Found') {
          this.errorMessage = 'Ingredient name already exists in FAsT. Please try again with a unique ingredient name.';
          this.segregatecompositionData = this.orgCompositionData;
          return false;
        } else {
          this.loadingmappinglistMessage = 'Fetching data from PLM';
          this.loading = true;
          const apiurl = environment.APIFAsT + '/generateuniqueingid/localing';
          this.apiService.getData(apiurl).subscribe((response) => {
            this.loading = false;
            this.uniqLocalIngID = response;
            if (this.uniqLocalIngID !== undefined) {
              this.editIngTable1Data[0].ingID = this.uniqLocalIngID[0];
              this.substanceListOfEditIng.forEach(element => {
                const sirQtyCalculated = (Number(this.editIngTable1Data[0].ingQuantity) * Number(element.sirPercentageInIng)) / 100;
                substanceRow = {
                  ingID: this.editIngTable1Data[0].ingID,
                  ingName: this.editIngTable1Data[0].ingDescription,
                  ingredientPer: this.editIngTable1Data[0].ingQuantity,
                  subName: element.subName,
                  sirId: element.sirId,
                  sirPercentageInIng: element.sirPercentageInIng,
                  casNumber: element.casNumber,
                  einecs: element.einecs,
                  errorDetails: element.errorDetails,
                  inciName: element.inciName,
                  pureCode: element.pureCode,
                  sirQty: sirQtyCalculated,
                  uom: element.uom,
                  isTemporaryIngredient: 1
                };
                this.segregatecompositionData.push(substanceRow);
                this.calculateingQtySIRQty();
              });
            }
            this.updateCompTableWithRoundedValues();
            this.segregatecompositionData = this.segregatecompositionData.concat(this.tempCompositionData);
            this.calculateingQtySIRQty();
            this.enableOrDisableCompleteRecipeBtn();
            this.editIngredientDialog = false;
          }, (error) => {
            this.loading = false;
            console.log(error);
          });
        }
      });
    } else {
      this.loadingmappinglistMessage = 'Checking for Duplicacy of Ingredient Name';
      if (Number(this.editIngTable1Data[0].isTemporaryIngredient) === 1) {
        this.loading = true;
        const encodedIngName = encodeURIComponent(this.editIngTable1Data[0].ingDescription.trim());
        const apiurlnew = environment.APIFAsT + '/getduplicacycheckoningredientname?ingname=' + encodedIngName;
        this.apiService.getData(apiurlnew).subscribe((response) => {
          this.loading = false;
          if (response.message === 'Duplicacy Found') {
            this.segregatecompositionData = this.orgCompositionData;
            this.errorMessage = 'Ingredient name already exists in FAsT. Please try again with a unique ingredient name.';
            this.segregatecompositionData = this.orgCompositionData;
            return false;
          } else {
            this.substanceListOfEditIng.forEach(element => {
              const sirQtyCalculated = (Number(this.editIngTable1Data[0].ingQuantity) * element.sirPercentageInIng) / 100;
              substanceRow = {
                ingID: this.editIngTable1Data[0].ingID,
                ingName: this.editIngTable1Data[0].ingDescription,
                ingredientPer: this.editIngTable1Data[0].ingQuantity,
                ingredientType: this.editIngTable1Data[0].ingType,
                subName: element.subName,
                sirId: element.sirId,
                sirPercentageInIng: element.sirPercentageInIng,
                casNumber: element.casNumber,
                einecs: element.einecs,
                errorDetails: element.errorDetails,
                inciName: element.inciName,
                pureCode: element.pureCode,
                sirQty: sirQtyCalculated,
                uom: element.uom,
                isTemporaryIngredient: 0
              };
              this.segregatecompositionData.push(substanceRow);
            });
            this.segregatecompositionData = this.segregatecompositionData.concat(this.tempCompositionData);
            this.updateCompTableWithRoundedValues();
            this.calculateingQtySIRQty();
            this.enableOrDisableCompleteRecipeBtn();
            this.editIngredientDialog = false;

          }
        });

      } else {
        // If ingredient ID remains unchanged
        this.substanceListOfEditIng.forEach(element => {
          const sirQtyCalculated = (Number(this.editIngTable1Data[0].ingQuantity) * element.sirPercentageInIng) / 100;
          substanceRow = {
            ingID: this.editIngTable1Data[0].ingID,
            ingName: this.editIngTable1Data[0].ingDescription,
            ingredientPer: this.editIngTable1Data[0].ingQuantity,
            ingredientType: this.editIngTable1Data[0].ingType,
            subName: element.subName,
            sirId: element.sirId,
            sirPercentageInIng: element.sirPercentageInIng,
            casNumber: element.casNumber,
            einecs: element.einecs,
            errorDetails: element.errorDetails,
            inciName: element.inciName,
            pureCode: element.pureCode,
            sirQty: sirQtyCalculated,
            uom: element.uom,
            isTemporaryIngredient: 0
          };
          this.segregatecompositionData.push(substanceRow);
        });
        this.segregatecompositionData = this.segregatecompositionData.concat(this.tempCompositionData);
        this.updateCompTableWithRoundedValues();
        this.calculateingQtySIRQty();
        this.enableOrDisableCompleteRecipeBtn();
        this.editIngredientDialog = false;

      }

    }
  }
  openEditIngPopUp(rowData) {
    this.errorMessage = '';
    this.errorIngMessage = 'No records found';
    this.isIngDescriptionDisabled = true;
    this.dynamicMinLen = 3;
    this.onClearEditIngredient();
    this.editIngSelection = rowData;
    let temporaryflag;
    if (this.editIngSelection.ingID.toString().substring(0, 4) === '1000') {
      this.isIngDescriptionDisabled = true;
      temporaryflag = 0;
      this.editIngTable1Data = [{
        ingID: this.editIngSelection.ingID,
        ingDescription: this.editIngSelection.ingName,
        ingQuantity: this.editIngSelection.ingredientPer,
        oldingID: this.editIngSelection.ingID,
        isTemporaryIngredient: temporaryflag,
        ingType: this.editIngSelection.ingredientType
      }];
      this.getSubstanceListOfEditIng(this.editIngSelection.ingID);
      this.updateTotalSirPercent();
      this.editIngredientDialog = true;
      this.validateEditIngPopup();
      this.searchIdentifierValue = '';
      this.selectedSubstance = '';
      this.substanceOptions = [];
      this.onestarIngID = '';
      this.plmvalidityareaedit = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
      this.plmkeydate = new Date();
      this.add6DecimalPlacesInEditIng();
    } else {
      this.loadingmappinglistMessage = 'Fetching data for Ingredient';
      this.loading = true;
      const apiurl = environment.APIFAsT + '/getcompletedlocaling/' + this.editIngSelection.ingID;
      this.apiService.getData(apiurl).subscribe((response) => {
        this.loading = false;
        if (response.ingID !== null) {
          temporaryflag = 0;
          this.isIngDescriptionDisabled = true;
        } else {
          temporaryflag = 1;
          this.isIngDescriptionDisabled = false;
        }
        this.editIngTable1Data = [{
          ingID: this.editIngSelection.ingID,
          ingDescription: this.editIngSelection.ingName,
          ingQuantity: this.editIngSelection.ingredientPer,
          oldingID: this.editIngSelection.ingID,
          isTemporaryIngredient: temporaryflag,
          ingType: this.editIngSelection.ingredientType
        }];
        this.getSubstanceListOfEditIng(this.editIngSelection.ingID);
        this.updateTotalSirPercent();
        this.editIngredientDialog = true;
        this.validateEditIngPopup();
        this.searchIdentifierValue = '';
        this.selectedSubstance = '';
        this.substanceOptions = [];
        this.onestarIngID = '';
        this.plmvalidityareaedit = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
        this.plmkeydate = new Date();
        this.add6DecimalPlacesInEditIng();
      }, (error) => {
        this.loading = false;
        console.log(error);
      });
    }

  }
  closeEditIngPopup() {
    this.onClearEditIngredient();
    this.editIngredientDialog = false;
  }
  resetEditIngIngredientID() {
    this.isIngDescriptionDisabled = false;
    if (this.editIngTable1Data[0].isTemporaryIngredient === 0) {
      this.editIngTable1Data[0].ingID = '--';
    }
  }
  showIngDeleteConfirmation() {
    this.showConfirmDelete = true;
  }
  deleteIng() {
    this.editIngTable1Data[0].ingQuantity = 0;
    this.editIngTable1Data[0].ingID = '--';
    this.substanceListOfEditIng = [];
    this.tempCompositionData = this.segregatecompositionData;
    this.segregatecompositionData = [];
    this.segregatecompositionData = this.tempCompositionData.filter(f => f.ingID !== this.editIngTable1Data[0].oldingID);
    this.showConfirmDelete = false;
    this.editIngredientDialog = false;
    this.calculateingQtySIRQty();
  }

  onInputChangeRecipeDesc(event: any) {
    const value = event.target.value;
    if (value === undefined || value === '' || value.trim() === '') {
      this.savebuttonflg = 1;
    } else {
      this.savebuttonflg = 0;
    }
  }

  validateEditIngQty(value: string) {
    this.editIngTable1Data[0].ingQuantity = value;
    this.validateEditIngPopup();
  }
  validateEditIngPopup() {
    this.popupNotValidated = false;
    if (this.substanceListOfEditIng.length <= 0) {
      this.popupNotValidated = true;
    }
    if (!this.isValidTotalRange(this.totalSirPercent, false)) {
      this.popupNotValidated = true;
    }
    if (this.editIngTable1Data[0].ingQuantity <= 0) {
      this.popupNotValidated = true;
    }
    if (!this.editIngTable1Data[0].ingDescription || !this.editIngTable1Data[0].ingQuantity || this.editIngTable1Data[0].ingQuantity === '0') {
      this.popupNotValidated = true;
    }
    this.substanceListOfEditIng.forEach(element => {
      if (Number(element.sirPercentageInIng) === undefined || Number(element.sirPercentageInIng) <= 0 || Number(element.sirPercentageInIng) > 100.011) {
        this.popupNotValidated = true;
      }
    });
  }

  confirmNo() {
    this.showConfirmDelete = false;
  }

  //  checkAndConvertNumber(value) {
  //   if (typeof value === 'number') {
  //     return value; // It's already a number
  //   }
  //   if (typeof value === 'string') {
  //     const num = Number(value);
  //     if (!isNaN(num)) {
  //       return num; // Successfully converted to a number
  //     }
  //   }
  //   return NaN; // Return NaN if it's not a number or can't be converted
  // }

  addSubstancefrom1starsearchtoEditIngList(onestarIngID, validityArea, keyDate, plm = false, index = 0) {
    this.errorMessage = '';
    this.loadingmappinglistMessage = 'Fetching data from PLM';
    this.loading = true;
    if (plm) {
      this.importFromPLMDetail[index].errorMessagePlm = '';
      this.importFromPLMDetail[index].dynamicMinLen = 3;
    }

    if (!this.isValidIng(onestarIngID)) {
      this.loading = false;
      this.errorMessage = 'Invalid 1* Ingredient ID';
      if (plm) {
        this.importFromPLMDetail[index].errorMessagePlm = 'Invalid 1* Ingredient ID';
      }
      return false;
    }
    if (onestarIngID === this.editIngTable1Data[0].ingID) {
      this.loading = false;
      this.errorMessage = 'Substances in this ingredient are already present.';
      return false;
    }
    const apiurl = environment.APIFAsT + '/ingcode/' + onestarIngID + '/plmvalidityarea/' + validityArea.validityAreaCode + '/plmkeydate/20250507';
    let substance = {};
    const duplicateSubstanceList = [];
    const ingID = onestarIngID;
    this.apiService.getData(apiurl).subscribe((response) => {
      this.loading = false;
      this.OneStarAPIResponse = response;
      if (this.OneStarAPIResponse.ingPureDetails !== undefined && !plm) {
        this.OneStarAPIResponse.ingPureDetails.forEach(c => {
          // duplicacy check for substances in substance grid while importing data for 1* ingredient
          if (this.substanceListOfEditIng.filter(f => f.sirId === c.substanceID).length <= 0) {
            substance = {
              subName: c.substanceName,
              sirId: c.substanceID,
              sirPercentageInIng: c.recipeQuantity,
              pureCode: c.pureCode,
              casNumber: c.casNumber,
              inciName: c.inciNumber,
              einecs: c.einecsNumber,
              uom: c.recipeUoM
            };
            this.substanceListOfEditIng.push(substance);
            this.updateTotalSirPercent();
          } else {
            duplicateSubstanceList.push(c.substanceName);
          }
          this.updateTotalSirPercent();
          onestarIngID = '';
          this.validateEditIngPopup();
        });
        if (duplicateSubstanceList.length > 0) {
          const duplicateSubCommaSeparated = duplicateSubstanceList.join(', ');
          if (duplicateSubstanceList.length === 1) {
            this.errorMessage = 'Substance ' + duplicateSubCommaSeparated + ' from ' + ingID + ' is not added, as it was already present.';
          } else {
            this.errorMessage = 'Substances ' + duplicateSubCommaSeparated + ' from ' + ingID + ' are not added, as they were already present.';
          }
        }

      }
      if (this.OneStarAPIResponse.ingPureDetails !== undefined && plm) {
        this.OneStarAPIResponse.ingPureDetails.forEach(c => {
          if (this.importFromPLMDetail[index].ingPureDetails.filter(f => f.substanceID === c.substanceID).length <= 0) {
            substance = {
              substanceName: c.substanceName,
              substanceID: c.substanceID,
              pureQuantityPerItem: parseFloat(c.recipeQuantityToDisplay),
              delId: Math.random(),
              pureCode: c.pureCode,
              casNumber: c.casNumber,
              inciNumber: c.inciNumber,
              einecsNumber: c.einecsNumber,
              recipeUoM: c.recipeUoM
            };
            this.importFromPLMDetail[index].ingPureDetails.push(substance);
            this.importFromPLMDetail[index].ingID = '--';
          } else {
            duplicateSubstanceList.push(c.substanceName);
          }
        });
        if (duplicateSubstanceList.length > 0) {
          const duplicateSubCommaSeparated = duplicateSubstanceList.join(', ');
          if (duplicateSubstanceList.length === 1) {
            this.importFromPLMDetail[index].errorMessagePlm = 'Substance ' + duplicateSubCommaSeparated + ' from ' + ingID + ' is not added, as it was already present.';
          } else {
            this.importFromPLMDetail[index].errorMessagePlm = 'Substances ' + duplicateSubCommaSeparated + ' from ' + ingID + ' are not added, as they were already present.';
          }
        }

        this.updateTotalSirPercentplm();
        onestarIngID = '';
        // this.importFromPLMDetail = this.addSerialNumbers(this.importFromPLMDetail);
        this.add6DecimalPlacesInImportFromPlm();
      }
      this.resetEditIngIngredientID();
    }, (error) => {
      this.loading = false;
    });
  }
  getvalidityArea() {
    const apiurl = environment.APIFAsT + '/getvalidityarea';
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.validityAreavals = response1;
      if (this.importfromPLM) {
        this.validityarea = '';
      } else {
        this.validityarea = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
      }
      this.plmvalidityareaedit = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
    }, (error) => {
    });
  }
  getSubstanceListOfEditIng(ingID) {
    this.substanceListOfEditIng = [];
    this.segregatecompositionData.forEach(element => {
      let substance = {};
      if (element.ingID === ingID) {
        substance = {
          subName: element.subName,
          sirId: element.sirId,
          sirPercentageInIng: element.sirPercentageInIng,
          casNumber: element.casNumber,
          einecs: element.einecs,
          errorDetails: element.errorDetails,
          inciName: element.inciName,
          pureCode: element.pureCode,
          sirQty: element.sirQty,
          uom: element.uom,
          ingredientPer: element.ingredientPer,
          ingID: element.ingID,
          ingName: element.ingName,
          isTemporaryIngredient: element.isTemporaryIngredient
        };
        this.substanceListOfEditIng.push(substance);
      }
    });
    console.log(this.substanceListOfEditIng);

  }
  selectRow(row) {
    if (row._selection === null || row._selection === undefined) {
      this.buttonSelection = false;
    } else {
      this.buttonSelection = true;
    }
  }
  checkval(event) {
    if (event.target.value === '') {
      console.log(this.sirSearchResult);
      this.sirSearchResult = [];
      console.log(this.sirSearchResult);
      this.disablePureCode = false;
      this.searchIdentifierValue = null;
      this.sirDetails = [];
      this.sirObjSelectedIndex = null;
      this.showPuremsg = false;
      this.substanceOptions = [];
    }
  }

  searchSubstance(searchIdentifierValue, index = 0, calledFromImportFromPlm = false) {
    if (searchIdentifierValue === '') {
      searchIdentifierValue = this.searchIdentifierValue;
    }
    this.loading = true;
    this.loadingmappinglistMessage = 'Fetching Substances details';
    this.substanceOptions = [];
    this.errorMessage = '';
    if (calledFromImportFromPlm) {
      this.importFromPLMDetail[index].substanceOptions = [];
      this.importFromPLMDetail[index].errorMessagePlm = '';
    }
    const apiurl = environment.APIFAsT + '/substancesfornonplm/' + searchIdentifierValue;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.sirSearchResult = response1;
      this.loading = false;
      if (this.sirSearchResult[0] === null) {
        this.loading = false;
        this.errorMessage = 'No substances found.';
        if (calledFromImportFromPlm) {
          this.importFromPLMDetail[index].errorMessagePlm = 'No substances found.';
        }
        return false;
      }
      this.sirSearchResult.forEach(parent => {
        const subDetails = {
          pureCodeLst: [],
          pureCode: '',
          subName: parent.backboneIdentity,
          sirId: parent.sirIdentity,
          casNumber: '',
          inciName: '',
          einecs: ''
        };
        parent.names.forEach(child => {
          if (child.nameType === 'CAS') {
            subDetails.casNumber = child.name;
          } else if (child.nameType === 'INCI') {
            subDetails.inciName = child.name;
          } else if (child.nameType === 'EINECS') {
            subDetails.einecs = child.name;
          } else if (child.nameType === 'PLM Pure') {
            subDetails.pureCodeLst.push(child.name);
          }
        });
        const pureCodeInCommaSeparated = subDetails.pureCodeLst.join(',');
        subDetails.pureCode = pureCodeInCommaSeparated;
        if (calledFromImportFromPlm) {
          this.importFromPLMDetail[index].substanceOptions.push({
            label: parent.backboneIdentity,
            value: subDetails,
            isParent: true
          });
          parent.names.forEach(child => {
            this.importFromPLMDetail[index].substanceOptions.push({
              label: child.name,
              value: subDetails,
              isParent: false
            });
          });

          const dropdownArray = this.plmdropdowns.toArray();
          if (dropdownArray[index]) {
            dropdownArray[index].show();
          }
        } else {
          this.substanceOptions.push({
            label: parent.backboneIdentity,
            value: subDetails,
            isParent: true
          });
          parent.names.forEach(child => {
            this.substanceOptions.push({
              label: child.name,
              value: subDetails,
              isParent: false
            });
          });
          this.dropdown.show();
        }
      });
      //  console.log(this.dropdown,'this.plmdropdown')
      // this.plmdropdowns.forEach(dropdown => dropdown.show());
      //
    }, (error) => {
      this.loading = false;
    });
  }
  updateSubstanceTable() {
    this.errorMessage = '';
    if (this.selectedSubstance && this.selectedSubstance.subName && this.selectedSubstance.sirId) {
      if (this.substanceListOfEditIng.filter(f => f.sirId === this.selectedSubstance.sirId).length <= 0) {
        this.substanceListOfEditIng.push({
          subName: this.selectedSubstance.subName,
          sirId: this.selectedSubstance.sirId,
          sirPercentageInIng: 0,
          casNumber: this.selectedSubstance.casNumber,
          einecs: this.selectedSubstance.einecs,
          inciName: this.selectedSubstance.inciName,
          pureCode: this.selectedSubstance.pureCode,
          uom: '%'
        });
      } else {
        this.errorMessage = 'This substance is already present in substance list.';
      }
    }
    this.resetEditIngIngredientID();
    this.validateEditIngPopup();
    this.add6DecimalPlacesInEditIng();
  }

  plmUpdateSubstanceTable(index) {
    this.importFromPLMDetail[index].errorMessagePlm = '';
    if (this.importFromPLMDetail[index].childselectedSubstance && this.importFromPLMDetail[index].childselectedSubstance.subName && this.importFromPLMDetail[index].childselectedSubstance.sirId) {
      if (this.importFromPLMDetail[index].ingPureDetails.filter(f => f.substanceID === this.importFromPLMDetail[index].childselectedSubstance.sirId).length <= 0) {
        const substance = {
          substanceName: this.importFromPLMDetail[index].childselectedSubstance.subName,
          substanceID: this.importFromPLMDetail[index].childselectedSubstance.sirId,
          pureQuantityPerItem: 0,
          delId: Math.random(),
          casNumber: this.importFromPLMDetail[index].childselectedSubstance.casNumber,
          einecsNumber: this.importFromPLMDetail[index].childselectedSubstance.einecs,
          inciNumber: this.importFromPLMDetail[index].childselectedSubstance.inciName,
          pureCode: this.importFromPLMDetail[index].childselectedSubstance.pureCode,
          recipeUoM: '%'

        };
        this.importFromPLMDetail[index].ingPureDetails.push(substance);
        this.importFromPLMDetail[index].ingID = '--';
        this.submitEnableDisable();
        this.importFromPLMDetail[index].isIngDescriptionDisabled = false;
      } else {
        this.importFromPLMDetail[index].errorMessagePlm = 'This substance is already present in substance list.';

      }
    }
    this.add6DecimalPlacesInImportFromPlm();
  }

  onSelectionChange(event: any) {
    const selectedItem = event.value;
    this.isAddSubstanceEnable = false;
    if (selectedItem === null) {
      this.selectedSubstance = null;
      this.isAddSubstanceEnable = true;
    }
  }

  updateTotalSirPercent(index = -1) {
    let totalSum = 0;
    this.substanceListOfEditIng.forEach(element => {
      element.sirPercentageInIng = Number(element.sirPercentageInIng);
      totalSum = totalSum + element.sirPercentageInIng;
    });
    this.totalSirPercent = totalSum;
    this.validateEditIngPopup();
    // Format all the other numbers to 6 decimals except the one being edited
    this.editIngTable1Data[0].ingQuantity = this.formatValueTo6DecimalPlaces(this.editIngTable1Data[0].ingQuantity);
    let j = 0;
    this.substanceListOfEditIng.forEach(substance => {
      if (index !== j) {
        substance.sirPercentageInIng = this.formatValueTo6DecimalPlaces(substance.sirPercentageInIng);
      }
      j++;
    });
  }

  // updateTotalSirPercentplm(i = 0) {
  //   let totalSum = 0;
  //   this.importFromPLMDetail.forEach(e => {
  //     e.ingPureDetails.forEach(c => {
  //       if (c.pureQuantityPerItem !== '') {
  //         totalSum = totalSum + parseFloat(c.pureQuantityPerItem);
  //       }
  //     });
  //     e.totalSirPercent = totalSum;
  //     totalSum = 0;
  //   });
  //   this.submitEnableDisable();
  // }

  resetPlmIngIngredientID(index) {
    this.importFromPLMDetail[index].isIngDescriptionDisabled = false;
    this.importFromPLMDetail[index].ingID = '--';
  }
  deleteSubstance(index: number) {
    this.substanceListOfEditIng.splice(index, 1);
    this.updateTotalSirPercent();
    this.resetEditIngIngredientID();
    this.add6DecimalPlacesInEditIng();
  }
  opendialogImportPLM() {
    this.isplmDataValid = false;
    this.clickedRows = [];
    this.importfromPlm = true;
    this.importFromPLMDetail = [];
    this.cucaltver = '';
    this.errorMessage = '';
    this.calculateImportIngQty();
    this.oldRecipeSourceValue = this.recipeSource;
    this.keydate = new Date();
    this.validityarea = '';
  }
  importfromPLM() {
    this.loading = true;
    this.errorMessage = '';
    this.loadingmappinglistMessage = 'Fetching data from PLM';
    console.log(this.validityarea, 'validityarea');
    const keydate = this.datePipe.transform(this.keydate, 'yyyyMMdd');
    const getimportFromPLM = environment.APIFAsT + '/recipe/' + this.cucaltver + '/recipieType/Z_General/plmvalidityarea/' + this.validityarea.validityDescription + '/plmkeydate/' + keydate;
    // const getimportFromPLM = environment.APIFAsT + '/recipe/200000279962/000/000/recipieType/Z_General/plmvalidityarea/undefined/plmkeydate/20250430';
    this.assessRequestRa.getData(getimportFromPLM).subscribe((result) => {
      if (result.message === 'One or more fields contains invalid data.  Please check the source data in PLM and try again') {
        this.loading = false;
        this.errorMessage = result.message;
      } else {
        this.importFromPLMDetail = result.formulationRequestDetailsIng.concat(this.importFromPLMDetail);
        this.importFromPLMDetail = this.addSerialNumbers(this.importFromPLMDetail);
        this.importFromPLMDetail = this.removeDuplicateswithQty(this.importFromPLMDetail, 'ingPureDetails', 'substanceID', 'recipeQuantity');
        this.roundNumbersInImportFromPlm();
        this.updateTotalSirPercentplm();
        this.loading = false;
        this.tfcDetailsfromPlm = result.tfc;
        this.calculateImportIngQty();
        this.submitEnableDisable();
        this.add6DecimalPlacesInImportFromPlm();
        // this.recipeSource = this.cucaltver;
        this.cucSource = this.cucaltver;
      }
    }, (error) => {
      this.loading = false;
      this.errorMessage = error.error.message;
      // this.matSnackBar.open(error.error.message, 'close', {
      //   duration: 30000,
      //   panelClass: ['error']
      // });
    });
  }

  roundNumbersInImportFromPlm() {
    this.importFromPLMDetail.forEach(ingredient => {
      ingredient.ingQuantity = this.roundIfMoreThan6Decimals(Number(ingredient.ingQuantity));

      ingredient.ingPureDetails.forEach(substance => {
        substance.pureQuantityPerItem = this.roundIfMoreThan6Decimals(Number(substance.pureQuantityPerItem));
        const sirQtyCalculated = (ingredient.ingQuantity * substance.pureQuantityPerItem) / 100;
        substance.recipeQuantity = this.roundIfMoreThan6Decimals(Number(sirQtyCalculated));
      });
    });
  }
  add6DecimalPlacesInImportFromPlm() {
    this.importFromPLMDetail.forEach(ingredient => {
      ingredient.ingQuantity = this.formatValueTo6DecimalPlaces(Number(ingredient.ingQuantity));
      ingredient.ingPureDetails.forEach(substance => {
        substance.pureQuantityPerItem = this.formatValueTo6DecimalPlaces(Number(substance.pureQuantityPerItem));
      });
    });
  }

  formatValueTo6DecimalPlaces(value) {
    if (value != null) {
      return value = parseFloat(value).toFixed(6);
    }
    return null;
  }
  removeDuplicates(arr, childKey, idKey) {
    const seenIds = new Set();
    return arr.map(obj => {
      if (obj[childKey] && Array.isArray(obj[childKey])) {
        obj[childKey] = obj[childKey].filter(child => {
          if (seenIds.has(child[idKey])) {
            return false; // Skip if ID is already seen
          } else {
            seenIds.add(child[idKey]);
            return true;  // Keep if ID is new
          }
        });
        seenIds.clear();
      }
      return obj;
    });
  }

  removeDuplicateswithQty(arr, childKey, idKey, idQty) {
    const seenIds = new Set();
    return arr.map(obj => {
      if (obj[childKey] && Array.isArray(obj[childKey])) {
        obj[childKey] = obj[childKey].filter(child => {
          const id = child[idKey];
          const qty = child[idQty];
          const compositekey = id + '_' + qty;
          if (seenIds.has(compositekey)) {
            return false; // Skip if ID is already seen
          } else {
            seenIds.add(compositekey);
            return true;  // Keep if ID is new
          }
        });
        seenIds.clear();
      }
      return obj;
    });
  }

  addIngredientDialogPlm() {
    const newrow = {
      specSerial: null,
      specID: null,
      isLocalIng: null,
      specDescription: null,
      specQuantity: 0.0,
      specUoM: null,
      ingID: '--',
      ingDescription: '',
      ingQuantity: 0.000000,
      ingUoM: null,
      ingType: '',
      ingError: null,
      ingPureDetails: [],
      otherRuleResults: null,
      delId: Math.random(),
      childingid: '',
      childvalidityArea: this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0],
      selectedIngItem: [],
      childkeydate: new Date(),
      childsearchIdentifierValue: '',
      childselectedSubstance: [],
      errorMessagePlm: '',
      substanceOptions: [],
      errorIngMessage: ' ',
      dynamicMinLen: 3,
      isIngDescriptionDisabled: false
    };
    this.importFromPLMDetail.unshift(newrow);
    // this.importFromPLMDetail.push(newrow);
    this.filteredIngItems = [];
    this.selectedIngItem = [];
    this.selectedSubstance = '';
    this.searchIdentifierValue = '';
    this.addSerialNumbers(this.importFromPLMDetail);
    this.updateTotalSirPercentplm();
    this.calculateImportIngQty();
    this.submitEnableDisable();
    this.add6DecimalPlacesInImportFromPlm();
  }
  importfromSubstance() {

  }
  importfromPLM1() {

  }
  onClearImportFromPlm() {
    this.cucaltver = '';
    this.validityarea = '';
    this.validityarea = '';
    this.keydate = new Date();
  }

  onClearEditIngredient() {
    this.onestarIngID = '';
    this.plmvalidityareaedit = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
    this.plmkeydate = new Date();
    this.searchIdentifierValue = '';
    this.selectedSubstance = '';
    this.substanceOptions = [];
    this.errorMessage = '';
    this.isAddSubstanceEnable = true;
    this.selectedIngItem = [];
    this.substanceOptions = [];
    this.selectedSubstance = '';
    this.filteredIngItems = [];
  }
  searchValidityArea(event) {
    const filtered: any[] = [];
    const query = event.query;
    for (const value of this.validityAreavals) {
      this.validityAreaVal = value.validityDescription;
      if (this.validityAreaVal.toLowerCase().includes(query.toLowerCase())) {
        filtered.push(this.validityAreaVal);
      }
    }
    this.filteredvalidityArea = filtered;
  }
  convertToDateFormat(date) {
    const year = date.substring(0, 4);
    const month = date.substring(4, 6);
    const day = date.substring(6, 8);
    const displayDate = day + '-' + month + '-' + year;
    return displayDate;
  }
  test(event, mc) {
    this.formAssess.plmkeydate = mc.inputFieldValue;
  }
  onTabClick(activeTab) {
    this.activeTab = activeTab;
    localStorage.removeItem('FormObj');
  }
  onCucChanged() {

  }
  deleteIngrow(pId) {
    console.log('In delete Ing');
    this.importFromPLMDetail = this.importFromPLMDetail.filter(item => item.delId !== pId);
    this.calculateImportIngQty();
    this.submitEnableDisable();
    this.add6DecimalPlacesInImportFromPlm();
  }
  deleteIngclildrow(cId, i) {
    console.log('In delete Ing');
    this.importFromPLMDetail = this.deleteObjectFromNestedArray(this.importFromPLMDetail, cId);
    this.importFromPLMDetail[i].ingID = '--';
    this.importFromPLMDetail[i].isIngDescriptionDisabled = false;
    this.updateTotalSirPercentplm();
  }

  submitEnableDisable() {
    this.errorMessage = '';
    this.isplmDataValid = false;
    let errorExist = false;
    for (let i = 0; i < this.importFromPLMDetail.length; i++) {
      if (!this.importFromPLMDetail[i].ingDescription) {
        this.errorMessage = 'Enter Ingredient Name for ' + this.importFromPLMDetail[i].ingID;
        errorExist = true;
        break;
      }
      if (!this.importFromPLMDetail[i].ingQuantity) {
        if (Math.abs(Number(this.importFromPLMDetail[i].ingQuantity)) < 1e-6) {
          this.errorMessage = 'Ing Level in Recipe (%) is zero for ' + this.importFromPLMDetail[i].ingID;
        } else {
          this.errorMessage = 'Enter Ing Level in Recipe (%) for ' + this.importFromPLMDetail[i].ingID;
        }
        errorExist = true;
        break;
      }
      if (Math.round(this.importFromPLMDetail[i].totalSirPercent) !== 100) {
        this.errorMessage = 'Total SIR % for \'' + this.importFromPLMDetail[i].ingDescription + '\' is not 100';
        errorExist = true;
        break;
      }
      for (let j = 0; j < this.importFromPLMDetail[i].ingPureDetails.length; j++) {
        if (!this.importFromPLMDetail[i].ingPureDetails[j].pureQuantityPerItem) {
          if (this.importFromPLMDetail[i].ingPureDetails[j].pureQuantityPerItem === 0) {
            this.errorMessage = 'SIR % is zero for ' + this.importFromPLMDetail[i].ingPureDetails[j].substanceID + ' in ingredient \'' + this.importFromPLMDetail[i].ingDescription + '\'';
          } else {
            this.errorMessage = 'Enter SIR % for ' + this.importFromPLMDetail[i].ingPureDetails[j].substanceID + ' in ingredient \'' + this.importFromPLMDetail[i].ingDescription + '\'';
          }
          errorExist = true;
          break;
        }
      }
    }
    if (this.importFromPLMDetail.length === 0) {
      errorExist = true;
    } else {
      if (!this.isValidTotalRange(this.calculatedImpINGQty, true)) {
        errorExist = true;
      }
    }
    if (!errorExist) {
      this.isplmDataValid = true;
    }

  }

  addSerialNumbers(arr) {
    return arr.map((obj, index) => {
      const newObj = { ...obj, delId: index + 1, childingid: '', childvalidityArea: this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0], childkeydate: new Date(), searchIdentifierValue: '', selectedSubstance: [], errorMessagePlm: '', substanceOptions: [], selectedIngItem: [], errorIngMessage: ' ', dynamicMinLen: 3, isIngDescriptionDisabled: true };
      if (obj.isIngDescriptionDisabled !== undefined) {
        newObj.isIngDescriptionDisabled = obj.isIngDescriptionDisabled;
      }
      if (obj.ingPureDetails && Array.isArray(obj.ingPureDetails)) {
        newObj.ingPureDetails = obj.ingPureDetails.map((child, childIndex) => ({
          ...child,
          delId: `${index + 1}.${childIndex + 1}`,
        }));
      }
      return newObj;
    });
  }

  deleteObjectFromNestedArray(arr, idToDelete) {
    for (let i = 0; i < arr.length; i++) {
      if (Array.isArray(arr[i])) {
        arr[i] = arr[i].filter(item => item.delId !== idToDelete);
      } else if (typeof arr[i] === 'object' && arr[i] !== null) {
        for (const key in arr[i]) {
          if (Array.isArray(arr[i][key])) {
            arr[i][key] = arr[i][key].filter(item => item.delId !== idToDelete);
          }
        }
      }
    }
    return arr;
  }
  // Starts ADD ING Related Functions
  onAddINGTabClick(activeTab) {
    this.loadingmappinglistMessage = activeTab === 'divSIR' ? 'Fetching SIR details' : 'Fetching ING details';
  }
  selectedKeyDate(event, mc) {
    this.plmkeydate = mc.inputFieldValue;
  }
  onValidityAreaChanged(selectedData) {
    this.plmvalidityarea = selectedData.validityAreaCode;
    if (this.plmvalidityarea === undefined) {
      this.plmvalidityarea = this.validityarea.validityAreacode;
      this.additionalfielderror = false;
    } else {
      this.additionalfielderror = false;
    }
    /* istanbul ignore if */
    if (selectedData === undefined) {
      this.plmkeydate = this.defaultStartDate;
    }
  }
  GetINGData() {
    this.loading = true;
    this.errorMessage = '';
    this.loadingmappinglistMessage = 'Fetching ING Details';
    if (!this.isValidIng(this.ingredientIdOrName)) {
      this.loading = false;
      this.errorMessage = 'Invalid 1* Ingredient ID';
      return false;
    }
    if (this.substanceDetailsData.length === 0 && this.isSIRClicked === false ) {
      this.isIngDescriptionDisabled = true;
    }
    const apiurl = environment.APIFAsT + '/ingcode/' + this.ingredientIdOrName + '/plmvalidityarea/' + this.plmvalidityarea + '/plmkeydate/' + this.convertDateToyyyyMMdd(this.plmkeydate);
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.loading = false;
      if (response1 === null) {
        this.errorMessage = 'Unable to import the ingredient as it is inactive in PLM';
        return false;
      }
      this.ingResponseData = response1;

      if (this.substanceDetailsData.length > 0) {
        this.setHypenToIngID();
      } else {
        this.createIngHeaderInformation(this.ingResponseData.ingID, this.ingResponseData.ingDescription, this.ingResponseData.ingQuantity, this.ingResponseData.ingType);
      }
      const duplicateSubstanceList = [];
      const ingID = this.ingredientIdOrName;
      this.ingResponseData.ingPureDetails.forEach(element => {
        if (this.substanceDetailsData.length > 0) {
          const exists = this.substanceDetailsData.some(detailsData => detailsData.substanceID === element.substanceID && detailsData.substanceName === element.substanceName);
          if (!exists) {
            this.substanceDetailsData.push(element);
          } else {
            duplicateSubstanceList.push(element.substanceName);
          }
        } else {
          this.substanceDetailsData.push(element);
        }
      });
      if (duplicateSubstanceList.length > 0) {
        const duplicateSubCommaSeparated = duplicateSubstanceList.join(', ');
        if (duplicateSubstanceList.length === 1) {
          this.errorMessage = 'Substance ' + duplicateSubCommaSeparated + ' from ' + ingID + ' is not added, as it was already present.';
        } else {
          this.errorMessage = 'Substances ' + duplicateSubCommaSeparated + ' from ' + ingID + ' are not added, as they were already present.';
        }
      }
      this.updateTotalAddIngSirPercent();
      this.loading = false;
    }, (error) => {
      this.loading = false;
      this.isIngDescriptionDisabled = false;
    });
  }
  isImportAddEnable() {
    if (this.ingredientIdOrName !== '' && this.plmvalidityarea !== '' && this.plmkeydate !== '') {
      return true;
    } else {
      return false;
    }
  }
  handleClear(type) {
    if (type === 'add') {
      this.plmvalidityarea = '';
    } else if (type === 'edit') {
      this.plmvalidityareaedit = '';
    }

  }
  isImportAddEnableForEditIng() {
    if (this.onestarIngID !== '' && this.plmvalidityareaedit.validityAreaCode && this.plmkeydate !== '') {
      return true;
    } else {
      return false;
    }
  }
  isImportAddEnableplm(selectedIngItem, childvalidityArea, childkeydate) {
    if (this.isPlainObject(selectedIngItem) && Object.keys(selectedIngItem).length > 0 && childvalidityArea !== null && childkeydate !== '') {
      return true;
    } else {
      return false;
    }
  }
  isPlainObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
  }
  cancelPopup() {
    this.clearAll();
    this.addIngredient = false;
  }
  updateTotalAddIngSirPercent(index = -1) {
    let totalSum = 0;
    this.substanceDetailsData.forEach(element => {
      if (element.recipeQuantity !== undefined && element.recipeQuantity !== '' && element.recipeQuantity !== null) {
        totalSum = totalSum + parseFloat(element.recipeQuantity);
      }
    });
    this.totalSirPercent = Math.round(totalSum * 1e6) / 1e6;
    this.disableIngSubmitButton();

    // Format all the other numbers to 6 decimals except the one being edited
    let j = 0;
    this.ingHeaderDataInformation[0].ingQuantity = this.formatValueTo6DecimalPlaces(this.ingHeaderDataInformation[0].ingQuantity);
    this.substanceDetailsData.forEach(s => {
      if (index !== j) {
        s.recipeQuantity = this.formatValueTo6DecimalPlaces(s.recipeQuantity);
      }
      j++;
    });
  }
  deleteAddIngSubstance(index: number) {
    this.setHypenToIngID();
    this.substanceDetailsData.splice(index, 1);
    this.updateTotalAddIngSirPercent();
    this.plmvalidityarea = this.validityarea.validityAreaCode;
  }
  deleteAddIng() {
    this.ingHeaderDataInformation = [];
    this.ingHeaderData.ingDescription = '';
    this.ingHeaderData.ingID = '--';
    this.ingHeaderData.ingQuantity = 0;
    this.ingHeaderData.ingType = '';
    this.substanceDetailsData = [];
    this.totalSirPercent = 0;
    this.plmvalidityarea = this.validityarea.validityAreaCode;
  }
  clearAll() {
    this.dynamicMinLen = 3;
    this.ingredientIdOrName = '';
    this.validityarea = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
    this.plmvalidityarea = this.validityarea.validityAreacode;
    this.plmkeydate = this.defaultStartDate;
    this.errorMessage = '';
    this.isAddSubstanceEnable = true;
    this.searchIdentifierValue = '';
    this.substanceOptions = [];
    this.selectedSubstance = '';
    this.filteredIngItems = [];
    this.selectedIngItem = [];
  }
  isValidIng(ingValue) {
    const isNumeric = /^\d+$/.test(ingValue);
    let isValid = true;
    if (isNumeric) {
      isValid = /^1\d{11}$/.test(ingValue);
    }
    return isValid;
  }
  ValidateOnlyIng(ingValue) {
    const isNumeric = /^\d+$/.test(ingValue);
    let isValid = false;
    if (isNumeric) {
      isValid = /^1\d{11}$/.test(ingValue);
    }
    return isValid;
  }
  submitIngDetails() {
    this.compositionnotvalidated = 1;
    this.tempCompositionData = this.segregatecompositionData;
    this.loadingmappinglistMessage = 'Checking for Duplicacy of Ingredient Name';
    this.loading = true;
    if (this.tempCompositionData.length > 0 && this.isIngDescriptionDisabled === true && this.tempCompositionData.filter(f => f.ingID === this.ingHeaderDataInformation[0].ingID).length > 0) {
      this.errorMessage = 'Ingredient already exists in this recipe.';
      this.loading = false;
      return false;
    }
    if (this.tempCompositionData.length > 0 && this.tempCompositionData.filter(f => f.ingName.trim().toLowerCase() === this.ingHeaderDataInformation[0].ingDescription.trim().toLowerCase()).length > 0) {
      this.errorMessage = 'Ingredient name already exists in this recipe. Please try again with a unique ingredient name.';
      this.loading = false;
      return false;
    }
    this.loading = false;
    this.tempCompositionData = this.tempCompositionData.filter(f => f.ingID !== this.ingHeaderDataInformation[0].ingID);
    this.segregatecompositionData = [];
    let substanceRow = {};
    if (this.ingHeaderDataInformation[0].ingID === '--') {
      this.loadingmappinglistMessage = 'Checking for Duplicacy of Ingredient Name';
      this.loading = true;
      const encodedIngName = encodeURIComponent(this.ingHeaderDataInformation[0].ingDescription.trim());
      const apiurlnew = environment.APIFAsT + '/getduplicacycheckoningredientname?ingname=' + encodedIngName;
      this.apiService.getData(apiurlnew).subscribe((response1) => {
        this.loading = false;
        if (response1.message === 'Duplicacy Found') {
          this.errorMessage = 'Ingredient name already exists in FAsT. Please try again with a unique ingredient name.';
          this.segregatecompositionData = this.tempCompositionData;
          this.calculateingQtySIRQty();
          return false;
        } else {
          this.loadingmappinglistMessage = 'Fetching data from PLM';
          this.loading = true;
          const apiurl = environment.APIFAsT + '/generateuniqueingid/localing';
          this.apiService.getData(apiurl).subscribe((response) => {
            this.loading = false;
            this.uniqLocalIngID = response;
            if (this.uniqLocalIngID !== undefined) {
              this.ingHeaderDataInformation[0].ingID = this.uniqLocalIngID[0];
              this.substanceDetailsData.forEach(element => {
                substanceRow = {
                  ingID: this.ingHeaderDataInformation[0].ingID,
                  ingName: this.ingHeaderDataInformation[0].ingDescription,
                  ingredientPer: Number(this.ingHeaderDataInformation[0].ingQuantity),
                  ingredientType: this.ingHeaderDataInformation[0].ingType,
                  subName: element.substanceName.trim(),
                  sirId: element.substanceID.trim(),
                  sirPercentageInIng: Number(element.recipeQuantity),
                  casNumber: element.casNumber,
                  einecs: element.einecsNumber,
                  errorDetails: element.substanceError,
                  inciName: element.inciNumber,
                  pureCode: element.pureCode,
                  sirQty: (Number(this.ingHeaderDataInformation[0].ingQuantity) * Number(element.recipeQuantity)) / 100,
                  uom: element.recipeUoM,
                  isTemporaryIngredient: 1
                };
                this.segregatecompositionData.push(substanceRow);
              });
              this.segregatecompositionData = this.segregatecompositionData.concat(this.tempCompositionData);
              this.updateCompTableWithRoundedValues();
              this.calculateingQtySIRQty();
              this.addIngredient = false;
            }
          }, (error) => {
            this.loading = false;
          });
        }
      });

    } else {
      // If ingredient ID remains unchanged
      this.substanceDetailsData.forEach(element => {
        substanceRow = {
          ingID: this.ingHeaderDataInformation[0].ingID,
          ingName: this.ingHeaderDataInformation[0].ingDescription,
          ingredientPer: this.ingHeaderDataInformation[0].ingQuantity,
          ingredientType: this.ingHeaderDataInformation[0].ingType,
          subName: element.substanceName.trim(),
          sirId: element.substanceID.trim(),
          sirPercentageInIng: element.recipeQuantity,
          casNumber: element.casNumber,
          einecs: element.einecsNumber,
          errorDetails: element.substanceError,
          inciName: element.inciNumber,
          pureCode: element.pureCode,
          sirQty: (this.ingHeaderDataInformation[0].ingQuantity * element.recipeQuantity) / 100,
          uom: element.recipeUoM,
          isTemporaryIngredient: 0
        };
        this.segregatecompositionData.push(substanceRow);
      });
      this.segregatecompositionData = this.segregatecompositionData.concat(this.tempCompositionData);
      this.updateCompTableWithRoundedValues();
      this.addIngredient = false;
    }
    this.calculateingQtySIRQty();
    // this.validateCompositionDetail();
  }
  setHypenToIngID() {
    this.isIngDescriptionDisabled = false;
    if (this.ingHeaderDataInformation.length > 0) {
      this.ingHeaderDataInformation[0].ingID = '--';
    }
  }
  onInputChange(event) {
    this.errorMessage = '';
    const value = (event.target as HTMLInputElement).value;
    if (value !== this.ingHeaderDataInformation[0].ingID) {
      this.setHypenToIngID();
    }
    this.disableIngSubmitButton();
  }
  onInputChangeEditIng() {
    this.errorMessage = '';
    this.resetEditIngIngredientID();
    this.validateEditIngPopup();
  }
  addSIRSubstanceTable() {
    this.errorMessage = '';
    let isItemNotExists = true;
    this.isIngDescriptionDisabled = false;
    this.isSIRClicked = true;
    // if Ingredient information exists then setting '--' for Ingredient ID.
    if (this.substanceDetailsData.length > 0) {
      this.setHypenToIngID();
    } else { // if No Ingredient information then by default setting with below values.
      this.createIngHeaderInformation('--', this.ingHeaderData.ingDescription, this.ingHeaderData.ingQuantity, '');
    }
    if (this.selectedSubstance && this.selectedSubstance.subName && this.selectedSubstance.sirId) {
      const names = this.sirSearchResult.filter(f => f.sirIdentity === this.selectedSubstance.sirId)[0].names;
      if (this.substanceDetailsData.length > 0) {
        const exists = this.substanceDetailsData.some(detailsData => detailsData.substanceID === this.selectedSubstance.sirId && detailsData.substanceName === this.selectedSubstance.subName);
        isItemNotExists = false;
        if (!exists) {
          isItemNotExists = true;
        }
      }
      if (isItemNotExists) {
        const eNumber = names.filter(n => n.nameType.toLowerCase() === 'e number');
        const einecs = names.filter(n => n.nameType.toLowerCase() === 'einecs');
        const inci = names.filter(n => n.nameType.toLowerCase() === 'inci');
        const cas = names.filter(n => n.nameType.toLowerCase() === 'cas');
        const plmPure = names.filter(n => n.nameType.toLowerCase() === 'plm pure');
        this.substanceDetailsData.push({
          casNumber: cas.length > 0 ? cas[0].name : '',
          convFactor: 0,
          eNumber: eNumber.length > 0 ? eNumber[0].name : '',
          einecsNumber: einecs.length > 0 ? einecs[0].name : '',
          inciNumber: inci.length > 0 ? inci[0].name : '',
          ingredientPath: null,
          insNumber: null,
          originalRecipeQuantity: null,
          parentCASNumber: '',
          pureCode: plmPure.length > 0 ? plmPure[0].name : 'No Pure Code Found',
          pureDescription: '',
          pureQuantityPerItem: 0,
          pureSerial: null,
          recipeQuantity: this.selectedSubstance.sirPercentageInIng === undefined ? '' : this.selectedSubstance.sirPercentageInIng,
          recipeQuantityToDisplay: '0.000',
          recipeUoM: '%',
          substanceError: this.selectedSubstance.sirId.trim() === '' ? 'SIR ID not found' : '',
          substanceID: this.selectedSubstance.sirId.trim(),
          substanceName: this.selectedSubstance.subName.trim(),
        });
      } else {
        this.errorMessage = 'This substance is already present in substance list.';
      }
    }
    this.disableIngSubmitButton();
  }
  createIngHeaderInformation(ingId, ingDescription, ingQuantity, ingType) {
    this.ingHeaderDataInformation = [];
    this.ingHeaderData.ingID = ingId;
    this.ingHeaderData.ingDescription = ingDescription;
    this.ingHeaderData.ingQuantity = ingQuantity === 0 ? null : ingQuantity;
    this.ingHeaderData.ingType = ingType;
    this.ingHeaderDataInformation.push(this.ingHeaderData);
    this.add6DecimalPlacesInAddIng();
  }
  convertDateToyyyyMMdd(inputDate) {
    const parts = inputDate.split('-');
    return this.datePipe.transform(new Date(+parts[2], +parts[1] - 1, +parts[0]), 'yyyyMMdd');
  }
  disableIngSubmitButton() {
    this.isIngValidData = true;
    if (this.ingHeaderDataInformation[0].ingID === '' || this.ingHeaderDataInformation[0].ingDescription.trim() === '' || this.ingHeaderDataInformation[0].ingQuantity === null || this.ingHeaderDataInformation[0].ingQuantity.toString() === '0') {
      this.isIngValidData = false;
    }
    if (!(this.isValidTotalRange(this.totalSirPercent, false))) {
      this.isIngValidData = false;
    }
    if (this.isIngValidData) {
      this.substanceDetailsData.forEach(s => {
        if (s.substanceName === '' || s.substanceID === '' || s.recipeQuantity <= 0 || s.substanceID === null) {
          this.isIngValidData = false;
        }
      });
    }
  }
  // Ends ADD ING Related Functions

  onClearTableData(index) {
    this.importFromPLMDetail[index].childingid = '';
    this.importFromPLMDetail[index].childvalidityArea = this.validityAreavals.filter(s => s.validityAreaCode === 'WORLD')[0];
    this.importFromPLMDetail[index].selectedIngItem = '';
    this.importFromPLMDetail[index].childkeydate = new Date();
    this.importFromPLMDetail[index].searchIdentifierValue = '';
    this.importFromPLMDetail[index].childselectedSubstance = [];
    this.importFromPLMDetail[index].childsearchIdentifierValue = '';
    this.importFromPLMDetail[index].errorMessagePlm = '';
    this.importFromPLMDetail[index].substanceOptions = [];
    this.importFromPLMDetail[index].errorIngMessage = ' ';
    this.importFromPLMDetail[index].dynamicMinLen = 3;
  }

  submitCreatePlmDetails() {
    console.log(this.importFromPLMDetail, 'this.importFromPLMDetail');
    this.compositionnotvalidated = 1;
    this.tempCompositionData = this.segregatecompositionData;
    const alreadyexistIng = [];
    this.importFromPLMDetail.forEach(e => {
      if (this.tempCompositionData.length > 0 && this.tempCompositionData.filter(f => f.ingID === e.ingID).length > 0) {
        alreadyexistIng.push(e.ingID);
      }
    });
    if (alreadyexistIng.length > 0) {
      this.errorMessage = 'ING IDs ' + alreadyexistIng.join(',') + ' already exists under Composition Details. Please delete these INGs to proceed.';
    } else {
      this.errorMessage = '';
      // Code to maintain Order of the ingrdeints
      // 1.First get all the custom Ing IDs by executing the API
      // 2.then push the Ing's to main table
      const totalCustomIdsNeeded = 0;

      // this.importFromPLMDetail.forEach(ingredient => {
      //   if (ingredient.ingID === '--') {
      //     totalCustomIdsNeeded++;
      //   }
      // });
      // if (totalCustomIdsNeeded !== 0) {
      //   this.generateCustomIngs(totalCustomIdsNeeded);
      // } else {
      //   this.pushIngsToMainTable([]);
      // }
      this.checkDuplicacy();
    }
  }
  async checkDuplicacy() {
    this.tempCompositionData = this.segregatecompositionData;
    this.loadingmappinglistMessage = 'Checking for Duplicacy of Ingredient Name';
    this.loading = true;
    let totalCustomIdsNeeded = 0;
    const duplicacyArray = [];
    const duplicacyIngArray = [];
    let ingnames = '';

    const hasDuplicate = new Set(this.importFromPLMDetail.map(item => item.ingDescription.trim().toLowerCase())).size !== this.importFromPLMDetail.length;
    if (hasDuplicate === true) {
      this.errorMessage = 'Ingredient name already exists in this recipe. Please try again with a unique ingredient name.';
      this.loading = false;
      return false;
    }

    for (let i = 0; i < this.importFromPLMDetail.length; i++) {
      if (this.importFromPLMDetail[i].ingID === '--') {
        if (this.tempCompositionData.length > 0 && this.tempCompositionData.filter(f => f.ingName.trim().toLowerCase() === this.importFromPLMDetail[i].ingDescription.trim().toLowerCase()).length > 0) {
          this.errorMessage = 'Ingredient name already exists in this recipe. Please try again with a unique ingredient name.';
          this.loading = false;
          return false;
        }
        const encodedIngName = encodeURIComponent(this.importFromPLMDetail[i].ingDescription.trim());
        const apiurlnew = environment.APIFAsT + '/getduplicacycheckoningredientname?ingname=' + encodedIngName;
        const response = await this.apiService.getData(apiurlnew).toPromise();
        if (response.message === 'Duplicacy Found') {
          duplicacyArray.push(response);
          duplicacyIngArray.push(this.importFromPLMDetail[i].ingDescription.trim());
        }
      }
    }
    if (duplicacyArray.length <= 0) {
      this.loading = false;
      this.importFromPLMDetail.forEach(ingredient => {
        if (ingredient.ingID === '--') {
          totalCustomIdsNeeded++;
        }
      });
      if (totalCustomIdsNeeded !== 0) {
        this.generateCustomIngs(totalCustomIdsNeeded);
      } else {
        this.pushIngsToMainTable([]);
      }
    } else {
      for (let i = 0; i < duplicacyIngArray.length; i++) {
        if (ingnames === '') {
          ingnames = duplicacyIngArray[i];
        } else {
          ingnames = ingnames + ', ' + duplicacyIngArray[i];
        }
      }
      this.loading = false;
      // this.errorMessage = ingnames + ' - already exists in records with same name. Please try with some different name';
      this. errorMessage = 'Ingredient name already exists in FAsT. Please try again with a unique ingredient name.';
      return false;

    }

  }
  async generateCustomIngs(totalCustomIdsNeeded) {
    this.loadingmappinglistMessage = 'Generating Custom Ingredient ID';
    this.loading = true;

    const customIngs = [];
    const apiurl = environment.APIFAsT + '/generateuniqueingid/localing';

    try {
      for (let i = 0; i < totalCustomIdsNeeded; i++) {
        const response = await this.apiService.getData(apiurl).toPromise();
        customIngs.push(response);
      }

      this.pushIngsToMainTable(customIngs);
    } catch (error) {
      console.error('Error in generating unique Ids:', error);
    } finally {
      this.loading = false;
    }
  }


  pushIngsToMainTable(customIngs) {
    let customIngsIndex = 0;
    this.segregatecompositionData = [];
    this.importFromPLMDetail.forEach(e => {
      this.tempCompositionData = this.tempCompositionData.filter(f => f.ingID !== e.ingID);
      let substanceRow = {};
      if (e.ingID === '--') {
        this.uniqLocalIngID = customIngs[customIngsIndex];
        customIngsIndex++;
        if (this.uniqLocalIngID !== undefined) {
          e.ingID = this.uniqLocalIngID[0];
          e.ingPureDetails.forEach(element => {
            substanceRow = {
              ingID: e.ingID,
              ingName: e.ingDescription,
              ingredientPer: e.ingQuantity,
              ingredientType: e.ingType,
              subName: element.substanceName,
              sirId: element.substanceID,
              sirPercentageInIng: element.pureQuantityPerItem,
              casNumber: element.casNumber,
              einecs: element.einecsNumber,
              errorDetails: element.substanceError,
              inciName: element.inciNumber,
              pureCode: element.pureCode,
              sirQty: (e.ingQuantity * element.pureQuantityPerItem) / 100,
              uom: '%',
              isTemporaryIngredient: 1
            };
            this.segregatecompositionData.push(substanceRow);
          });
        }
      } else {
        // If ingredient ID remains unchanged
        e.ingPureDetails.forEach(element => {
          substanceRow = {
            ingID: e.ingID,
            ingName: e.ingDescription,
            ingredientPer: e.ingQuantity,
            ingredientType: e.ingType,
            subName: element.substanceName,
            sirId: element.substanceID,
            sirPercentageInIng: element.pureQuantityPerItem,
            casNumber: element.casNumber,
            einecs: element.einecsNumber,
            errorDetails: element.substanceError,
            inciName: element.inciNumber,
            pureCode: element.pureCode,
            sirQty: (e.ingQuantity * element.pureQuantityPerItem) / 100,
            uom: '%',
            isTemporaryIngredient: 0
          };
          this.segregatecompositionData.push(substanceRow);
        });
      }
    });
    this.segregatecompositionData = this.segregatecompositionData.concat(this.tempCompositionData);
    this.updateCompTableWithRoundedValues();
    this.calculateingQtySIRQty();
    this.importfromPlm = false;
    this.importFromPLMDetail = [];
    this.isRecipeSourceImportFromPlm = true;
    this.cucaltver = '';
    this.populateTfcData(this.tfcDetailsfromPlm);
    this.recipeSource = this.cucSource;
  }

  updateTotalSirPercentplm() {
    let totalSum = 0;
    this.importFromPLMDetail.forEach(e => {
      e.ingPureDetails.forEach(c => {
        if (c.pureQuantityPerItem !== '') {
          totalSum = totalSum + parseFloat(c.pureQuantityPerItem);
        }
      });
      e.totalSirPercent = totalSum;
      this.isValidTotalRange(totalSum, false);
      totalSum = 0;
    });

    this.submitEnableDisable();
  }
  getLastLevelTfcId() {
    if (this.selectedSubClass) {
      return this.selectedSubClass.tfcLevel4Id;
    } else if (this.selectedClass) {
      return this.selectedClass.tfcLevel3Id;
    } else if (this.selectedType) {
      return this.selectedType.tfcLevel2Id;
    } else if (this.selectedFC) {
      return this.selectedFC.tfcLevel1Id;
    } else if (this.selectedUpd) {
      return this.selectedUpd.updId;
    } else {
      return '';
    }
  }
  async saveRecipeDetails() {
    const isRestrictedToValid = await this.validateRestrictedToEmails();
    if (!isRestrictedToValid) {
      this.matSnackBar.open(this.restrictedToError, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
      return;
    }
    if (this.editRecipeFlag && this.recipeId && this.recipeVersion) {
      this.checkOtherUserEditingRecipeOrNot();
    } else {
      // If not a edit recipe page then directly save recipe
      this.saveRecipeDetailsToDB();
    }
  }
  checkOtherUserEditingRecipeOrNot() {
    this.loading = true;
    const userDetails = JSON.parse(localStorage.getItem('userRolesPermissions'));
    this.loadingmappinglistMessage = 'Checking any other user is editing this recipe';
    const apiurl = environment.APIFAsT + '/execution/editnonplmrecipe';
    const apiBody = {
      RecipeDisplayID: this.recipeId + '/' + this.recipeVersion,
      EditUserID: userDetails.userId,
      EditFlag: 1
    };
    this.apiService.postData(apiurl, apiBody).subscribe((response) => {
      this.loading = false;
      console.log(response);
      if (response.status === 'Success') {
        // if no other user is currently editing recipe then save recipe
        this.saveRecipeDetailsToDB();
      } else {
        // if error exist, show snackbar error and redirect to recipe Worklist page
        this.matSnackBar.open(response.message, 'close', {
          duration: 3000,
          panelClass: ['error']
        });
        this.navigateToRecipeWorklist();
      }
    }, (error) => {
      this.loading = false;
      this.matSnackBar.open(error.error.message, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
    });
  }
  saveRecipeDetailsToDB() {
    let RecipeErrorFlg = 1;
    if (this.recipeDescription !== '') {
      console.log('save data');
      const errorsToResolveBeforeSubmit = this.validationsForSaveAndFinalizeForSaveButton();
      if (errorsToResolveBeforeSubmit.length > 0) {
        RecipeErrorFlg = 1;
      } else {
        RecipeErrorFlg = 0;
      }
      this.loadingmappinglistMessage = 'Saving recipe data';
      this.loading = true;
      const lastLevelTfcId = this.getLastLevelTfcId();
      const dataToBeSaved = {
        RECIPEHEADER: [
          {
            RecipeID: this.recipeId,
            RecipeDescription: this.recipeDescription,
            RecipeVer: this.recipeVersion,
            RecipeComments: this.recipeComment ? this.recipeComment : '',
            RecipeSource: this.recipeSource ? this.recipeSource : '',
            RecipeType: 'NonPLM',
            UPD: this.selectedUpd ? this.selectedUpd.updName : '',
            FORMULATIONCAT: this.selectedFC ? this.selectedFC.tfcLevel1Name : '',
            FORMULATIONTYPE: this.selectedType ? this.selectedType.tfcLevel2Name : '',
            FORMULATIONCLASS: this.selectedClass ? this.selectedClass.tfcLevel3Name : '',
            FORMULATIONSUBCLASS: this.selectedSubClass ? this.selectedSubClass.tfcLevel4Name : '',
            PreparationMethod: this.selectedPrepMethod ? this.selectedPrepMethod.value : '',
            RecipeStatusID: '',
            RecipeStatusDescription: '',
            UpdId: this.selectedUpd ? this.selectedUpd.updId : '',
            LastLevelTfcId: lastLevelTfcId,
            tfc: this.generateTfcHierarchyStr(),
            RecipeErrorFlag: RecipeErrorFlg
          }],
        completeFlag: 1,
        restrictedUsersIds: this.restrictedUsers ? this.restrictedUsers.join(',') : '',
        RecipeCompositionData: this.segregatecompositionData ? this.segregatecompositionData : []
      };
      console.log(dataToBeSaved);
      console.log('save data');
      const apiurl = environment.APIFAsT + '/createnonplmrecipe';
      this.apiService.postData(apiurl, dataToBeSaved).subscribe((response) => {
        this.loading = false;
        console.log(response);
        if (this.recipeId && this.recipeVersion) {
          // show only snack bar success msg for 2nd time and subsequent save
          this.matSnackBar.open('Recipe has been successfully saved.', 'close', {
            duration: 3000,
            panelClass: ['success']
          });
        } else {
          // show recipe-saved popup for 1st time save
          this.recipeId = response.RecipeID;
          this.recipeVersion = response.RecipeVer;
          this.showRecipeSavedDialog = true;
        }
      }, (error) => {
        this.loading = false;
        this.matSnackBar.open(error.error.message, 'close', {
          duration: 3000,
          panelClass: ['error']
        });
      });
    } else {
      this.matSnackBar.open('Please enter the Recipe Description before clicking Save', 'close', {
        duration: 3500,
        panelClass: ['error']
      });
    }
  }

  closeImportPopup() {
    this.importfromPlm = false;
    this.errorMessage = '';
    // this.recipeSource = this.oldRecipeSourceValue;

  }

  allowOnlyPositiveDecimal(event: KeyboardEvent, type: string) {
    const allowedChars = /[0-9.]/;
    const input = event.target as HTMLInputElement;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    } else if (event.key === '.' && input.value.includes('.')) {   // Prevent multiple decimals
      event.preventDefault();
    } else if (type === 'add') {
      this.setHypenToIngID();
    }
  }

  pasteOnlyPositiveDecimal(event: ClipboardEvent, type: string) {
    const allowedChars = /^\d*\.?\d*$/;
    const pastedText = event.clipboardData ? event.clipboardData.getData('text') : '';
    if (!allowedChars.test(pastedText)) {
      event.preventDefault();
    } else if (pastedText === '.' && pastedText.includes('.')) {   // Prevent multiple decimals
      event.preventDefault();
    } else if (type === 'add') {
      // 'add' = substance % field: changing it makes the ING custom, so reset ID to '--'
      // 'addQty' = ING quantity field: do NOT reset the ID
      this.setHypenToIngID();
    }
  }


  removeEditLockFromDB() {
    this.loadingmappinglistMessage = 'Removing Edit lock';
    this.loading = true;
    const userDetails = JSON.parse(localStorage.getItem('userRolesPermissions'));
    const apiurl = environment.APIFAsT + '/execution/editnonplmrecipe';
    const apiBody = {
      RecipeDisplayID: this.recipeId + '/' + this.recipeVersion,
      EditUserID: userDetails.userId,
      EditFlag: null
    };
    this.apiService.postData(apiurl, apiBody).subscribe((response) => {
      this.loading = false;
      console.log(response);
    }, (error) => {
      this.loading = false;
      this.matSnackBar.open(error.error.message, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
    });
  }

  onCancelClicked() {

    if (this.editRecipeFlag && this.recipeId && this.recipeVersion) {
      // Only For In-progress recipe Edit
      this.removeEditLockFromDB();
    }
    this.recipeDescription = '';
    this.recipeComment = '';
    this.clearDropdownvalues(true, true, true, true);
    this.selectedUpd = null;
    this.router.navigate(['/non-plm-recipe/manage-recipe']);
  }

  validationsForSaveAndFinalize() {
    const errorsToResolveBeforeSubmit = [];
    if ((this.recipeDescription === '' || this.recipeDescription.trim() === '' || !this.recipeDescription) && !(this.selectedUpd && this.selectedFC && this.selectedType && this.selectedClass && this.selectedSubClass && this.selectedPrepMethod)) {
      errorsToResolveBeforeSubmit.push('Please enter the Recipe Description and Formulation details before completing the recipe');
    } else {
      if (this.recipeDescription === '' || this.recipeDescription.trim() === '' || !this.recipeDescription) {
        errorsToResolveBeforeSubmit.push('Please enter the Recipe Description before completing the recipe');
      }
      if (!(this.selectedUpd && this.selectedFC && this.selectedType && this.selectedClass && this.selectedSubClass && this.selectedPrepMethod)) {
        errorsToResolveBeforeSubmit.push('Please enter the Formulation details before completing the recipe');
      }
    }
    if (!(this.isValidTotalRange(this.calculatedINGQty, true))) {
        errorsToResolveBeforeSubmit.push('Total ING quantity is not correct');
    }
    if (!(this.isValidTotalRange(this.calculatedSIRQty, false))) {
      errorsToResolveBeforeSubmit.push('Total SIR quantity is not correct');
    }
    for (let i = 0; i < this.segregatecompositionData.length; i++) {
      if (this.segregatecompositionData[i].errorDetails !== 'No Issues Found') {
        errorsToResolveBeforeSubmit.push('Please resolve errors present in Compostion Details.');
        break;
      }
    }
    return errorsToResolveBeforeSubmit;
  }

  validationsForSaveAndFinalizeForSaveButton() {
    const errorsToResolveBeforeSubmit = [];
    if ((this.recipeDescription === '' || this.recipeDescription.trim() === '' || !this.recipeDescription) && !(this.selectedUpd && this.selectedFC && this.selectedType && this.selectedClass && this.selectedSubClass && this.selectedPrepMethod)) {
      errorsToResolveBeforeSubmit.push('Please enter the Recipe Description and Formulation details before completing the recipe');
    } else {
      if (this.recipeDescription === '' || this.recipeDescription.trim() === '' || !this.recipeDescription) {
        errorsToResolveBeforeSubmit.push('Please enter the Recipe Description before completing the recipe');
      }
      if (!(this.selectedUpd && this.selectedFC && this.selectedType && this.selectedClass && this.selectedSubClass && this.selectedPrepMethod)) {
        errorsToResolveBeforeSubmit.push('Please enter the Formulation details before completing the recipe');
      }
    }
    if (!(this.isValidTotalRange(this.calculatedINGQty, true))) {
      if (this.segregatecompositionData.length !== 0) {
        errorsToResolveBeforeSubmit.push('Total ING quantity is not correct');
      }
    }
    if (!(this.isValidTotalRange(this.calculatedSIRQty, false))) {
      if (this.segregatecompositionData.length !== 0) {
        errorsToResolveBeforeSubmit.push('Total SIR quantity is not correct');
      }
    }
    if (this.segregatecompositionData.length !== 0) {
      for (let i = 0; i < this.segregatecompositionData.length; i++) {
        if (this.segregatecompositionData[i].errorDetails === 'No Issues Found' || this.segregatecompositionData[i].errorDetails === '' || this.segregatecompositionData[i].errorDetails === null) {
        } else {
          errorsToResolveBeforeSubmit.push('Please resolve errors present in Compostion Details.');
          break;
        }
      }
    }
    return errorsToResolveBeforeSubmit;
  }
  async saveAndFinalizeRecipe() {
    this.loading = true;
    const isRestrictedToValid = await this.validateRestrictedToEmails();

    if (!isRestrictedToValid) {
      this.matSnackBar.open(this.restrictedToError, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
      this.loading = false;
      return;
    }
    let substancestring = '';
    this.segregatecompositionData.forEach(item => {
      if (substancestring === '') {
        substancestring = item.sirId;
      } else {
        substancestring = substancestring + ', ' + item.sirId;
      }
    });

    this.loadingmappinglistMessage = 'Validating Substances';
    this.substanceOptions = [];
    const apiurl = environment.APIFAsT + '/substancelistfornonplm/' + substancestring;
    this.apiService.getData(apiurl).subscribe((response1) => {
      this.sirSearchResult = response1;
      this.segregatecompositionData.forEach(element => {
        const substanceFound = this.sirSearchResult.filter(f => f.sirId === element.sirId);
        if (substanceFound.length !== undefined) {
          if (substanceFound.length <= 0) {
            element.errorDetails = 'Invalid Substance';
          }
        } else {
          element.errorDetails = 'Invalid Substance';
        }
      });
      this.loading = false;
      console.log(this.substanceOptions);
      this.validateOtherDetailsforRecipe();
      const errorsToResolveBeforeSubmit = this.validationsForSaveAndFinalize();
      if (errorsToResolveBeforeSubmit.length > 0) {
        const errorsInString = errorsToResolveBeforeSubmit.join(', ');
        this.matSnackBar.open(errorsInString, 'close', {
          duration: 7000,
          panelClass: ['error']
        });
        if (this.recipeDescription !== undefined && this.recipeDescription !== '') {
          this.savebuttonflg = 0;
        } else {
          this.savebuttonflg = 1;
        }
      } else {
        this.checkIngNameDuplicityBeforeCompletingRcp();
      }
    }, (error) => {
      this.recipeValidated = 0;
      this.loading = false;
      this.lockform = 0;
      this.savebuttonflg = 0;
    });
  }
  saveAndFinalizeToDB() {
    this.lockform = 1;
    this.savebuttonflg = 1;
    console.log('save and finalize data');
    this.loadingmappinglistMessage = 'Submitting recipe data';
    this.loading = true;
    const lastLevelTfcId = this.getLastLevelTfcId();
    const dataToBeSaved = {
      RECIPEHEADER: [
        {
          RecipeID: this.recipeId,
          RecipeDescription: this.recipeDescription,
          RecipeVer: this.recipeVersion,
          RecipeComments: this.recipeComment ? this.recipeComment : '',
          RecipeSource: this.recipeSource ? this.recipeSource : '',
          RecipeType: 'NonPLM',
          UPD: this.selectedUpd.updName,
          FORMULATIONCAT: this.selectedFC.tfcLevel1Name,
          FORMULATIONTYPE: this.selectedType.tfcLevel2Name,
          FORMULATIONCLASS: this.selectedClass.tfcLevel3Name,
          FORMULATIONSUBCLASS: this.selectedSubClass.tfcLevel4Name,
          PreparationMethod: this.selectedPrepMethod.value,
          RecipeStatusID: '',
          RecipeStatusDescription: '',
          UpdId: this.selectedUpd.updId,
          LastLevelTfcId: lastLevelTfcId,
          tfc: this.generateTfcHierarchyStr(),
          RecipeErrorFlag: 0
        }],
      completeFlag: 2,
      restrictedUsersIds: this.restrictedUsers ? this.restrictedUsers.join(',') : '',
      RecipeCompositionData: this.segregatecompositionData
    };
    console.log(dataToBeSaved);
    console.log('save data');
    const apiurl = environment.APIFAsT + '/createnonplmrecipe';
    this.apiService.postData(apiurl, dataToBeSaved).subscribe((response) => {
      this.loading = false;
      console.log(response);
      this.recipeId = response.RecipeID;
      this.recipeVersion = response.RecipeVer;
      if (!this.redirectToCreateRequestPg) {
        this.showRecipeCompletedDialog = true;
      } else {
        this.showDialogAfterCreateReqClicked = true;
      }

    }, (error) => {
      this.loading = false;
      this.matSnackBar.open(error.error.message, 'close', {
        duration: 3000,
        panelClass: ['error']
      });
    });
  }

  generateTfcHierarchyStr() {
    let tfcLevel5Id = '';
    let tfcLevel5Name = '';
    let tfcLevel5FullText = '';
    if (this.selectedSubClass) {
      tfcLevel5Id = this.selectedSubClass.tfcLevel4Id;
      tfcLevel5Name = this.selectedSubClass.tfcLevel4Name;
      tfcLevel5FullText = this.selectedSubClass.tfcFullText;
    }
    let tfcLevel4Id = '';
    let tfcLevel4Name = '';
    let tfcLevel4FullText = '';
    if (this.selectedClass) {
      tfcLevel4Id = this.selectedClass.tfcLevel3Id;
      tfcLevel4Name = this.selectedClass.tfcLevel3Name;
      tfcLevel4FullText = this.selectedClass.tfcFullText;
    }
    let tfcLevel3Id = '';
    let tfcLevel3Name = '';
    let tfcLevel3FullText = '';
    if (this.selectedType) {
      tfcLevel3Id = this.selectedType.tfcLevel2Id;
      tfcLevel3Name = this.selectedType.tfcLevel2Name;
      tfcLevel3FullText = this.selectedType.tfcFullText;
    }
    let tfcLevel2Id = '';
    let tfcLevel2Name = '';
    let tfcLevel2FullText = '';
    if (this.selectedFC) {
      tfcLevel2Id = this.selectedFC.tfcLevel1Id;
      tfcLevel2Name = this.selectedFC.tfcLevel1Name;
      tfcLevel2FullText = this.selectedFC.tfcFullText;
    }
    let tfcLevel1Id = '';
    let tfcLevel1Name = '';
    let tfcLevel1FullText = '';
    if (this.selectedUpd) {
      tfcLevel1Id = this.selectedUpd.updId;
      tfcLevel1Name = this.selectedUpd.updName;
      tfcLevel1FullText = this.selectedUpd.updName;
    }

    const tfc = {
      tfcId: tfcLevel5Id,
      tfcName: tfcLevel5Name,
      tfcFullText: tfcLevel5FullText,
      tfcLevel: 5,
      parentTFC: {
        tfcId: tfcLevel4Id,
        tfcName: tfcLevel4Name,
        tfcFullText: tfcLevel4FullText,
        tfcLevel: 4,
        parentTFC: {
          tfcId: tfcLevel3Id,
          tfcName: tfcLevel3Name,
          tfcFullText: tfcLevel3FullText,
          tfcLevel: 3,
          parentTFC: {
            tfcId: tfcLevel2Id,
            tfcName: tfcLevel2Name,
            tfcFullText: tfcLevel2FullText,
            tfcLevel: 2,
            parentTFC: {
              tfcId: tfcLevel1Id,
              tfcName: tfcLevel1Name,
              tfcFullText: tfcLevel1FullText,
              tfcLevel: 1,
              parentTFC: null,
              bgid : tfcLevel1Id,
              businessGroupName: tfcLevel1Name
            }
          }
        }
      }
    };
    return tfc;
  }
  copyOrEditRecipe() {
    if (localStorage.getItem('viewOrEditFormObj')) {
      this.copyOrEditRecipeForm = JSON.parse(localStorage.getItem('viewOrEditFormObj'));
    }
    if (this.copyOrEditRecipeForm && this.copyOrEditRecipeForm.recipeHeader) {
      this.restrictedTovalue = this.copyOrEditRecipeForm.restrictedUsersIds;
      this.copyRecipeFlag = this.copyOrEditRecipeForm.copyRecipeFlag;
      this.editRecipeFlag = this.copyOrEditRecipeForm.editRecipeFlag;
      this.recipeId = this.copyOrEditRecipeForm.recipeHeader[0].recipeID;
      this.recipeDescription = this.copyOrEditRecipeForm.recipeHeader[0].recipeDescription;
      // if recipe complete flag is 1(in-progress recipe) then assign version else assign blank version
      this.recipeVersion = this.copyOrEditRecipeForm.completeFlag === 1 ? this.copyOrEditRecipeForm.recipeHeader[0].recipeVer : '';
      this.recipeComment = this.copyOrEditRecipeForm.recipeHeader[0].recipeComments;
      if (this.copyRecipeFlag) {
        this.recipeId = '';
        this.recipeVersion = '';
      }
      this.populateTfcData(this.copyOrEditRecipeForm.recipeHeader[0].tfc);
      this.segregatecompositionData = this.copyOrEditRecipeForm.recipeCompositionData;
      this.validateCompositionDetail();
      this.calculateingQtySIRQty();

      this.recipeSource = this.copyOrEditRecipeForm.recipeHeader[0].recipeSource;
      const regexOf2StarRcp = /^\d{12}\/\d{3}\/\d{3}$/;
      if (regexOf2StarRcp.test(this.recipeSource)) {
        this.isRecipeSourceImportFromPlm = true;
      } else {
        this.isRecipeSourceImportFromPlm = false;
      }
    }
  }

  // validatemandatoryentries()
  // {
  //   this.mandatoryentrymissing = 0;
  //   if(this.recipeDescription === null || this.recipeDescription === '')
  //   {
  //     this.mandatoryentrymissing = 1;
  //   }
  //   if (this.tfcDetailsfromPlm.tfcLevel1Id === null || this.tfcDetailsfromPlm.tfcLevel1Id === '')
  //   {
  //     this.mandatoryentrymissing = 1;
  //   }
  //    if (this.tfcDetailsfromPlm.tfcLevel2Id === null || this.tfcDetailsfromPlm.tfcLevel2Id === '')
  //   {
  //     this.mandatoryentrymissing = 1;
  //   }
  //    if (this.tfcDetailsfromPlm.tfcLevel3Id === null || this.tfcDetailsfromPlm.tfcLevel3Id === '')
  //   {
  //     this.mandatoryentrymissing = 1;
  //   }
  //    if (this.tfcDetailsfromPlm.tfcLevel4Id === null || this.tfcDetailsfromPlm.tfcLevel4Id === '')
  //   {
  //     this.mandatoryentrymissing = 1;
  //   }
  //    if (this.tfcDetailsfromPlm.tfcLevel5Id === null || this.tfcDetailsfromPlm.tfcLevel5Id === '')
  //   {
  //     this.mandatoryentrymissing = 1;
  //   }
  //   if(this.calculatedImpINGQty < 99.99 || this.calculatedImpINGQty > 100.01)
  //   {
  //     this.mandatoryentrymissing = 1;
  //   }
  //   if(this.calculatedImpINGQty < 99.99 || this.calculatedImpINGQty > 100.01)
  //   {
  //     this.mandatoryentrymissing = 1;
  //   }


  // }
  navigateToRecipeWorklist() {
    this.router.navigate(['/non-plm-recipe/manage-recipe']);
  }

  openCreateRequestPage() {
    this.createRequestForm.nonPlmrecipeId = this.recipeId + '/' + this.recipeVersion;
    this.createRequestForm.nonPlmrecipeId_Version = this.recipeId + '_' + this.recipeVersion;
    localStorage.setItem('FormObj', JSON.stringify(this.createRequestForm));
    localStorage.setItem('selectedStep', '1');
    this.dataTrans.setSelectedStep(1);
    this.router.navigate(['assess-requests/create-request-nonplm']);
  }
  roundIfMoreThan6Decimals(num: number): number {
    const decimalPart = num.toString().split('.')[1];
    if (decimalPart && decimalPart.length > 6) {
      return Math.round(num * 1e6) / 1e6;
    }
    return num;
  }
  updateCompTableWithRoundedValues() {
    this.segregatecompositionData.forEach(element => {
      // First round Ingredient % and SIR % in ING
      element.ingredientPer = this.roundIfMoreThan6Decimals(Number(element.ingredientPer));
      element.sirPercentageInIng = this.roundIfMoreThan6Decimals(Number(element.sirPercentageInIng));

      // calculate new SIR Qty with rounded values and also round obtained SIR Qty value
      const sirQtyCalculated = (element.ingredientPer * element.sirPercentageInIng) / 100;
      element.sirQty = this.roundIfMoreThan6Decimals(Number(sirQtyCalculated));
    });
  }
  scrollToSubstanceTable(index: number): void {
    setTimeout(() => {
      const element = document.getElementById('substanceDetailsTable-' + index);
      if (element && this.clickedRows.indexOf(index) === -1) {
        this.clickedRows.push(index);
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (element && this.clickedRows.indexOf(index) !== -1) {
        // If the row is already clicked, remove it from the clickedRows array
        this.clickedRows = this.clickedRows.filter(rowIndex => rowIndex !== index);
      }
    }, 100);
  }
  calculateImportIngQty() {
    this.calculatedImpINGQty = 0.000000;
    let ingquanty = 0.00000;
    this.importFromPLMDetail.forEach(e => {
      e.ingQuantity = Math.round(Number(e.ingQuantity) * 1e6) / 1e6; // Round to 6 decimal places
      ingquanty = ingquanty + e.ingQuantity;
    });
    this.calculatedImpINGQty = (Math.round(Number(ingquanty) * 1e6) / 1e6); // Round to 6 decimal places
    this.isValidTotalRange(ingquanty, true);
  }
  ingQuantityChange(index) {
    let j = 0;
    this.calculateImportIngQty();
    this.submitEnableDisable();
    // Format all the other numbers to 6 decimals except the one being edited
    this.importFromPLMDetail.forEach(ingredient => {
      if (index !== j) {
        ingredient.ingQuantity = this.formatValueTo6DecimalPlaces(Number(ingredient.ingQuantity));
      }
      j++;
    });
  }

  searchIng(event: any, type: string, index: number = 0, isBackspaceOrDelete: boolean = false) {
    const query = event.query === undefined ? event : event.query;
    this.ingredientIdOrName = '';
    this.onestarIngID = '';
    if (query.trim() === '') {
      this.loading = false;
      return false;
    }
    this.plmIngredient = [];
    this.filteredIngItems = [];
    if (query.startsWith('100') && query.length >= 1 && isBackspaceOrDelete === false) {
      this.dynamicMinLen = 12; // If query starts with '1000', set minimum length to 4
      if (query.length === 12) {
        this.plmIngredient.push({ ingDescription: '', ingID: query });
        this.filteredIngItems = this.plmIngredient;
      }
      if (type === 'import') {
        this.importFromPLMDetail[index].dynamicMinLen = 12; // Set minimum length to 12 for import
      }
    } else {
      this.dynamicMinLen = 3; // Otherwise, set minimum length to 3
      if (type === 'import') {
        this.importFromPLMDetail[index].dynamicMinLen = 3; // Reset to default minimum length for import
      }

      // Your filtering logic here
      this.filteredIngItems = this.items.filter(item =>
        item.toLowerCase().includes(query.toLowerCase())
      );

      this.loading = true;
      const apiurl = environment.APIFAsT + '/viewnonplminglist/' + query;
      this.apiService.getData(apiurl).subscribe((response) => {
        this.loading = false;
        if (response.length === 0) {
          this.selectedIngItem = [];
          let validIngId = '';
          this.ValidateOnlyIng(query) ? validIngId = query : validIngId = '';
          if (type === 'add') {
            // this.ingredientIdOrName = validIngId;
            if (validIngId !== '') {
              this.ingDetails.ingDescription = '';
              this.ingDetails.ingID = validIngId;
              response.push(this.ingDetails);

            } else {
              this.resetData();
            }
          } else if (type === 'edit') {
            // this.onestarIngID = validIngId;
            if (validIngId !== '') {
              this.ingDetails.ingDescription = '';
              this.ingDetails.ingID = validIngId;
              response.push(this.ingDetails);
            } else {
              this.resetData();
            }
          } else if (type === 'import') {
            // this.importFromPLMDetail[index].childingid = validIngId;
            if (validIngId !== '') {
              this.ingDetails.ingDescription = '';
              this.ingDetails.ingID = validIngId;
              response.push(this.ingDetails);
              this.importFromPLMDetail[index].errorIngMessage = '  ';
            } else {
              this.importFromPLMDetail[index].dynamicMinLen = 3; // Reset to default minimum length
              this.importFromPLMDetail[index].errorIngMessage = 'No records found';
            }
          } else {
            this.errorIngMessage = '  ';
          }
        }
        if (response.length > 0) {
          this.errorIngMessage = '  ';
        }
        this.filteredIngItems = response;
      }, (error) => {
        this.loading = false;
        this.errorIngMessage = 'No records found';
      });
    }

  }
  resetData() {
    this.dynamicMinLen = 3; // Reset to default minimum length
    this.errorIngMessage = 'No records found';
  }
  clearINGItems(type: string = '', index: number = 0) {
    this.filteredIngItems = [];
    this.ingredientIdOrName = '';
    this.selectedIngItem = [];
    this.errorMessage = '';
    this.onestarIngID = '';
    this.dynamicMinLen = 3;
    this.errorIngMessage = '  ';
    if (type === 'add' && (this.substanceDetailsData.length === 0 || this.isSIRClicked === true)) {
      this.isIngDescriptionDisabled = false;
      this.plmvalidityarea = this.validityarea.validityAreaCode;
    }
    if (type === 'import ') {
      this.importFromPLMDetail[index].childingid = '';
      this.importFromPLMDetail[index].dynamicMinLen = 3; // Reset to default minimum length
      this.importFromPLMDetail[index].errorIngMessage = '  ';
    }
  }
  ingSelected(event: any, type: string, index: number = 0) {
    if (type === 'add') {
      this.ingredientIdOrName = event.ingID;
    } else if (type === 'edit') {
      this.onestarIngID = event.ingID;
    } else if (type === 'import') {
      this.importFromPLMDetail[index].childingid = event.ingID;
      this.isImportAddEnableplm(this.importFromPLMDetail[index].selectedIngItem, this.importFromPLMDetail[index].childvalidityArea, this.importFromPLMDetail[index].childkeydate);
    }
  }
  // common function
  isValidTotalRange(quantity, isING): boolean {
    let isValidRange = true;
    if (isING) {
      this.invalidINGCalc = !(this.roundIfMoreThan6Decimals(parseFloat(quantity)) >= 99.99 && this.roundIfMoreThan6Decimals(parseFloat(quantity)) <= 100.01);
      isValidRange = !this.invalidINGCalc;
    } else {
      this.invalidSIRCalc = !(this.roundIfMoreThan6Decimals(parseFloat(quantity)) >= 99.99 && this.roundIfMoreThan6Decimals(parseFloat(quantity)) <= 100.01);
      isValidRange = !this.invalidSIRCalc;
    }
    return isValidRange;
  }
  handlePaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData ? event.clipboardData.getData('text') : '';
    const allowedPattern = /^[a-zA-Z0-9',\-&% ]*$/;
    if (!allowedPattern.test(pastedInput)) {
      event.preventDefault();
    }
  }
  restrictSpecialChars(event: KeyboardEvent) {
    const allowedPattern = /^[a-zA-Z0-9',\-&% ]$/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!allowedPattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  onInputChangeIng(event: KeyboardEvent, type: string, index) {
    let value = '';
    let isBackspaceOrDelete = false;
    value = (event.target as HTMLInputElement).value;
    if (event.key === 'Backspace' || event.key === 'Delete') {
      if (typeof (event) === 'object') {
        value = (event.target as HTMLInputElement).value;
      } else {
        value = event;
      }
      isBackspaceOrDelete = true;
    }
    // if((!value.startsWith('1000') && value.length >= 3) || (value.startsWith('1000') && value.length === 12)) {
    if (value.length >= this.dynamicMinLen) {
      this.errorIngMessage = '  ';
      this.searchIng(value, type, index, isBackspaceOrDelete);
    }
  }

  add6DecimalPlacesInEditIng() {
    this.editIngTable1Data[0].ingQuantity = this.formatValueTo6DecimalPlaces(this.editIngTable1Data[0].ingQuantity);
    this.substanceListOfEditIng.forEach(substance => {
      substance.sirPercentageInIng = this.formatValueTo6DecimalPlaces(substance.sirPercentageInIng);
    });
  }

  add6DecimalPlacesInAddIng() {
    this.ingHeaderDataInformation[0].ingQuantity = this.formatValueTo6DecimalPlaces(this.ingHeaderDataInformation[0].ingQuantity);
    this.substanceDetailsData.forEach(s => {
      s.recipeQuantity = this.formatValueTo6DecimalPlaces(s.recipeQuantity);
    });
  }
  openSelectrecipe() {
    this.showredirectpopup = false;
    this.router.navigate(['assess-requests/select-recipe']);
  }


  enableOrDisableCompleteRecipeBtn() {
    const errors = this.validationsForSaveAndFinalize();
    if (errors.length > 0) {
      this.compositionnotvalidated = 1;
    } else {
      this.compositionnotvalidated = 0;
    }
    this.validateRestrictedToEmails();
  }
  nonPLMDialog() {
    this.isCreateRecipeDialog = false;
  }
  onNotifyClicked(details) {
    this.selectedIssueCategory = [];
    this.commentsToUser = '';
    if (this.selectedUpd === undefined) {
      this.matSnackBar.open('Please enter business group', 'close', {
        duration: 5000,
        panelClass: ['error']
      });
      return false;
    }
    this.isNotifyClicked = true;
    this.rowDetails = details;
    this.issueCategoryList = [
      { name: 'SIR ID', value: 'SIR ID' },
      { name: 'PURE CODE', value: 'PURE CODE' },
      { name: 'CAS#', value: 'CAS#' },
      { name: 'INCI Name', value: 'INCI' },
      { name: 'EINECS', value: 'EINECS#' },
    ];
  }
  sendMailtoGPC() {
    let emailData = '';
    emailData = emailData + '\r\nPure Code:' + ' ' + this.rowDetails['pureCode'] + '\r\n[SIR ID :' + ' ' + this.rowDetails['sirId'] + ']' +
      '\r\nBackbone Identity :' + ' ' + this.selectedIssueCategory.map((s) => s.value).toString() + '. ' + '\r\n' + 'Comments : ' + ' ' + this.commentsToUser + '\r\n'
      + 'Pure Description : ' + ' ' + this.rowDetails['ingName'] + '\r\n';
    const data = {
      NotificationGroup: 'GPC',
      Subject: null,
      EmailBody: emailData,
      ToEmailList: null,
      FromEmail: null,
      CCEmailList: null,
      EmailType: 'html',
      UPD: this.selectedUpd.updName,
      PureCodes: this.rowDetails['pureCode'],
      RequestID: null,
      IsPLMRequest: false
    };
    const apiurl = environment.APIFAsT + '/email';
    this.assessRequestRa.postData(apiurl, data).subscribe((response) => {
      if (response.message !== null) {
        this.loading = false;
        this.matSnackBar.open('Email message sent to SERS team successfully', 'close', {
          duration: 5000,
          panelClass: ['success']
        });
      }
    }, (error) => {
      return false;
    });
  }
  DeleteAllIngredients() {
    this.importFromPLMDetail = [];
    this.calculatedImpINGQty = 0.000000;
    this.isValidTotalRange(this.calculatedImpINGQty, true);
    this.submitEnableDisable();
    this.matSnackBar.open('All ingredients have been deleted successfully', 'close', {
      duration: 3000,
      panelClass: ['success']
    });
  }
  DeleteAllCompositionDetails() {
    this.segregatecompositionData = [];
    this.tempCompositionData = [];
    this.calculatedINGQty = 0.000000;
    this.calculatedSIRQty = 0.000000;
    this.validateOtherDetailsforRecipe();
    this.calculateingQtySIRQty();
    this.matSnackBar.open('All Ingredients have been deleted successfully from Composition Details', 'close', {
      duration: 3000,
      panelClass: ['success']
    });
  }
  disableArrowKeys(event: KeyboardEvent): void {
    const blockedKeys = ['ArrowUp', 'ArrowDown'];
    if (blockedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  async checkIngNameDuplicityBeforeCompletingRcp() {
    this.loadingmappinglistMessage = 'Checking for Duplicacy of Ingredient Name';
    this.loading = true;

    // Get Unique Ingredients with their ID and name
    const uniqueIngredients = [
      ...new Map(this.segregatecompositionData.map(obj => [obj.ingID,
      { ingID: obj.ingID, ingName: obj.ingName }])
      ).values()
    ];
    // Add non-completed Ings into nonCompletedIngNames array
    const nonCompletedIngNames = [];
    try {
      for (let i = 0; i < uniqueIngredients.length; i++) {
        if (uniqueIngredients[i].ingID.toString().substring(0, 4) !== '1000') {
          const apiurl = environment.APIFAsT + '/getcompletedlocaling/' + uniqueIngredients[i].ingID;
          const response = await this.apiService.getData(apiurl).toPromise();
          if (!response.ingID) {
            nonCompletedIngNames.push(uniqueIngredients[i].ingName.trim());
          }
        }
      }

      // Check any of the name is duplicate
      const duplicateIngNames = [];
      for (let i = 0; i < nonCompletedIngNames.length; i++) {
        const encodedIngName = encodeURIComponent(nonCompletedIngNames[i].trim());
        const apiurlnew = environment.APIFAsT + '/getduplicacycheckoningredientname?ingname=' + encodedIngName;
        const response = await this.apiService.getData(apiurlnew).toPromise();
        if (response.message === 'Duplicacy Found') {
          duplicateIngNames.push(nonCompletedIngNames[i].trim());
        }
      }
      this.loading = false;
      this.cdr.detectChanges();

      if (duplicateIngNames.length > 0) {
        const errorMsg = duplicateIngNames.join(', ') + ' - Ingredient name already exists in FAsT. Please try again with a unique ingredient name.';
        this.matSnackBar.open(errorMsg, 'close', {
            duration: 3000,
            panelClass: ['custom-snackbar-error'],
          });
      } else {
        this.showFinalizeConfirmation = true;
        this.cdr.detectChanges();
      }
    } catch (error) {
      console.error('Error in checking duplicate Ing name :', error);
    } finally {
      this.loading = false;
    }
  }
  async validateRestrictedToEmails(): Promise<boolean> {
    this.loadingMessage = 'Validating the users';
    this.loading = true;
    const inputValue = (this.restrictedTovalue || '').trim();

    if (!inputValue) {
      this.loading = false;
      this.restrictedToError = '';
      return true;
    }

    if ((!this.copyOrEditRecipeForm || this.editFlagFirst !== 0) && (this.selectedFC === '' || this.selectedFC === undefined || this.selectedFC === null)) {
      this.loading = false;
      this.restrictedTovalue = '';
      this.restrictedToError = 'Please select Formulation Category before entering Restricted To emails.';
      return false;
    } else if (this.copyOrEditRecipeForm && this.editFlagFirst === 0) {
      this.loading = false;
      this.editFlagFirst = 1;
      return true;
    }
    const emails = inputValue
      .split(',')
      .map(email => email.trim())
      .filter(email => email !== '');

    const emailPattern = /^[A-Za-z0-9._%+-]+@unilever\.com$/i;
    const invalidEmails = emails.filter(email => !emailPattern.test(email));

    if (invalidEmails.length > 0) {
      this.loading = false;
      this.restrictedToError = 'Please enter a valid comma separated Unilever email address (e.g., name@unilever.com)';
      return false;
    }
    const normalizedEmails = emails.map(email => email.toLowerCase());
    const duplicateEmails = emails.filter((email, index) => {
      return normalizedEmails.indexOf(email.toLowerCase()) !== index;
    });

    const uniqueDuplicateEmails = [...new Set(duplicateEmails.map(email => email.toLowerCase()))];

    if (uniqueDuplicateEmails.length > 0) {
      this.loading = false;
      this.restrictedToError = 'Duplicate email address(es) found. Please remove duplicates.';
      return false;
    }
    const apiurlUser = environment.APIFAsT + '/getUserValidations';
    const apiBody = emails.map(email => ({
      emails: email,
      marketId: 0,
      categoryId: this.selectedFC.tfcLevel1Id || 0,
      requestType: 'CreateRecipe'
    }));

    try {
      const response = await this.apiService.postData(apiurlUser, apiBody).toPromise() as any[];
      this.loading = false;
      const hasRaUserAuthorize = response.some(item => item.message === 'No matching TechnicalFormulationCategoryId mapping found for CreateRecipe.');
      if (hasRaUserAuthorize) {
        this.restrictedToError = 'One or more email IDs are not associated with the selected Category.';
        return false;
      }
      const hasRaUserRole = response.some(item => item.message === 'User is not active or no FAST role is assigned.');
      if (hasRaUserRole) {
        this.restrictedToError = 'One or more email addresses provided are not active FAsT users.';
        return false;
      }
      const inactiveEmails = response
        .filter(item => item && item.isValid === false)
        .map(item => item.email);
      if (inactiveEmails.length > 0) {
        const label = inactiveEmails.length > 1 ? 'are' : 'is';
        this.restrictedToError =
          `${inactiveEmails.join(', ')} ${label} not an active user in the system. Please provide an active email address`;
        return false;
      }

      this.restrictedUsers = response.filter(item => item.emailID !== 0).map(item => item.emailID);
      this.restrictedToError = '';
      this.restrictedTovalue = emails.join(', ');
      return true;
    } catch {
      this.loading = false;
      this.restrictedToError = 'Unable to validate Restricted To emails.';
      return false;
    }
  }
}
